import { Injectable, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Component, Input, Output, ViewChild, HostListener, NgModule, Inject } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorIntl, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog, MatButtonModule as MatButtonModule$1, MatDialogModule } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import 'hammerjs';
import { TinyColor } from '@ctrl/tinycolor';
import { MatListModule } from '@angular/material/list';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/flex-layout/flex';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/flex-layout/extended';
import * as ɵngcc5 from '@angular/material/paginator';
import * as ɵngcc6 from '@angular/material/table';
import * as ɵngcc7 from '@angular/material';
import * as ɵngcc8 from '@angular/cdk/drag-drop';
import * as ɵngcc9 from '@angular/material/menu';
import * as ɵngcc10 from '@angular/material/icon';
import * as ɵngcc11 from '@angular/material/button-toggle';
import * as ɵngcc12 from '@angular/material/checkbox';
import * as ɵngcc13 from '@angular/material/button';
import * as ɵngcc14 from '@angular/material/slide-toggle';
import * as ɵngcc15 from '@angular/material/tooltip';
import * as ɵngcc16 from 'ngx-color-picker';
import * as ɵngcc17 from '@angular/material/list';

const _c0 = ["rbCrudContainer"];
function CrudComponent_div_3_mat_button_toggle_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-button-toggle", 24);
    ɵngcc0.ɵɵlistener("click", function CrudComponent_div_3_mat_button_toggle_5_Template_mat_button_toggle_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.activeFilter(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 25);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 26);
    ɵngcc0.ɵɵelement(3, "path", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "mat-form-field", 20);
    ɵngcc0.ɵɵelementStart(2, "mat-icon", 21);
    ɵngcc0.ɵɵtext(3, "search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 22);
    ɵngcc0.ɵɵlistener("keyup", function CrudComponent_div_3_Template_input_keyup_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.applyFilter($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, CrudComponent_div_3_mat_button_toggle_5_Template, 4, 0, "mat-button-toggle", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.displayFilter);
} }
function CrudComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 28);
} }
function CrudComponent_ng_container_11_div_1_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 33);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r15.header, " ");
} }
const _c1 = function (a0) { return { "rb-text-decoration-action": a0 }; };
function CrudComponent_ng_container_11_div_1_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 34);
    ɵngcc0.ɵɵlistener("click", function CrudComponent_ng_container_11_div_1_td_2_Template_td_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const row_r24 = ctx.$implicit; const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(); return column_r15.action ? column_r15.action(row_r24, ctx_r25.parentScope) : ""; });
    ɵngcc0.ɵɵelementStart(1, "span", 35);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r24 = ctx.$implicit;
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵstyleProp("cursor", column_r15.action ? "pointer" : "default");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c1, column_r15.action));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r15.dataName(row_r24) && column_r15.dataName(row_r24) !== "" && column_r15.dataName(row_r24) !== null && column_r15.dataName(row_r24) != "undefined" ? column_r15.dataName(row_r24) : "--", " ");
} }
function CrudComponent_ng_container_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_1_th_1_Template, 2, 1, "th", 31);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_1_td_2_Template, 3, 6, "td", 32);
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_ng_container_11_div_2_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 38);
} }
function CrudComponent_ng_container_11_div_2_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 39);
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 40);
    ɵngcc0.ɵɵtext(2, "drag_indicator");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_ng_container_11_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_2_th_1_Template, 1, 0, "th", 36);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_2_td_2_Template, 3, 0, "td", 37);
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_ng_container_11_div_3_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 42);
    ɵngcc0.ɵɵelementStart(1, "mat-checkbox", 43);
    ɵngcc0.ɵɵlistener("change", function CrudComponent_ng_container_11_div_3_th_1_Template_mat_checkbox_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(3); return $event ? ctx_r34.masterToggle() : null; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r32 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r32.selection.hasValue() && ctx_r32.isAllSelected())("indeterminate", ctx_r32.selection.hasValue() && !ctx_r32.isAllSelected())("aria-label", ctx_r32.checkboxLabel())("disabled", column_r15.disabledParam);
} }
function CrudComponent_ng_container_11_div_3_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 39);
    ɵngcc0.ɵɵelementStart(1, "mat-checkbox", 44);
    ɵngcc0.ɵɵlistener("click", function CrudComponent_ng_container_11_div_3_td_2_Template_mat_checkbox_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); return $event.stopPropagation(); })("change", function CrudComponent_ng_container_11_div_3_td_2_Template_mat_checkbox_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); const row_r37 = ctx.$implicit; const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return $event ? ctx_r40.selection.toggle(row_r37) : null; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ctx.$implicit;
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r33 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r33.selection.isSelected(row_r37))("aria-label", ctx_r33.checkboxLabel(row_r37))("disabled", row_r37[column_r15.disabledParam]);
} }
function CrudComponent_ng_container_11_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_3_th_1_Template, 2, 4, "th", 41);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_3_td_2_Template, 2, 3, "td", 37);
    ɵngcc0.ɵɵelementEnd();
} }
const _c2 = function (a0, a1) { return { "rb-fixed-button-column": a0, "rb-float-button-column": a1 }; };
function CrudComponent_ng_container_11_div_4_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 47);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c2, column_r15.buttonConfig.isFixed, !column_r15.buttonConfig.isFixed));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r15.buttonConfig.isFixed && column_r15.buttonConfig.header ? column_r15.buttonConfig.header : "", " ");
} }
function CrudComponent_ng_container_11_div_4_td_2_button_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(column_r15.buttonConfig.icon);
} }
function CrudComponent_ng_container_11_div_4_td_2_button_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 53);
    ɵngcc0.ɵɵelement(2, "path", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c3 = function (a0) { return { "rb-float-button": a0 }; };
function CrudComponent_ng_container_11_div_4_td_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r54 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 52);
    ɵngcc0.ɵɵlistener("click", function CrudComponent_ng_container_11_div_4_td_2_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r54); const row_r45 = ɵngcc0.ɵɵnextContext().$implicit; const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r52 = ɵngcc0.ɵɵnextContext(); return column_r15.buttonConfig.action(row_r45, ctx_r52.parentScope); });
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_4_td_2_button_1_mat_icon_1_Template, 2, 1, "mat-icon", 30);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_4_td_2_button_1_mat_icon_2_Template, 3, 0, "mat-icon", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r45 = ɵngcc0.ɵɵnextContext().$implicit;
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c3, !column_r15.buttonConfig.isFixed))("disabled", row_r45[column_r15.buttonConfig.disabledParam]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.buttonConfig.icon !== "rbLinkIcon");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.buttonConfig.icon === "rbLinkIcon");
} }
function CrudComponent_ng_container_11_div_4_td_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r60 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 55);
    ɵngcc0.ɵɵlistener("menuOpened", function CrudComponent_ng_container_11_div_4_td_2_button_2_Template_button_menuOpened_0_listener() { ɵngcc0.ɵɵrestoreView(_r60); const row_r45 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r58 = ɵngcc0.ɵɵnextContext(3); return ctx_r58.saveSelectedLineMenu(row_r45); })("menuClosed", function CrudComponent_ng_container_11_div_4_td_2_button_2_Template_button_menuClosed_0_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r61 = ɵngcc0.ɵɵnextContext(4); return ctx_r61.selectedLineId = null; });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-icon");
    ɵngcc0.ɵɵtext(4, "arrow_drop_down");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r45 = ɵngcc0.ɵɵnextContext().$implicit;
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵnextContext();
    const _r8 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c3, !column_r15.buttonConfig.isFixed))("matMenuTriggerFor", _r8)("matMenuTriggerData", row_r45)("disabled", row_r45[column_r15.buttonConfig.disabledParam]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(column_r15.buttonConfig.title);
} }
function CrudComponent_ng_container_11_div_4_td_2_mat_slide_toggle_3_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-slide-toggle", 56, 57);
    ɵngcc0.ɵɵlistener("dragChange", function CrudComponent_ng_container_11_div_4_td_2_mat_slide_toggle_3_Template_mat_slide_toggle_dragChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r67); const _r64 = ɵngcc0.ɵɵreference(1); const row_r45 = ɵngcc0.ɵɵnextContext().$implicit; const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r65 = ɵngcc0.ɵɵnextContext(); return column_r15.buttonConfig.action(column_r15.dataName(row_r45), ctx_r65.parentScope, _r64.checked, _r64); })("toggleChange", function CrudComponent_ng_container_11_div_4_td_2_mat_slide_toggle_3_Template_mat_slide_toggle_toggleChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r67); const _r64 = ɵngcc0.ɵɵreference(1); const row_r45 = ɵngcc0.ɵɵnextContext().$implicit; const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r69 = ɵngcc0.ɵɵnextContext(); return column_r15.buttonConfig.action(column_r15.dataName(row_r45), ctx_r69.parentScope, _r64.checked, _r64); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r45 = ɵngcc0.ɵɵnextContext().$implicit;
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("matTooltip", column_r15.buttonConfig.subtitle);
    ɵngcc0.ɵɵproperty("matTooltipDisabled", !row_r45[column_r15.buttonConfig.showSubtitleParam])("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c3, !column_r15.buttonConfig.isFixed))("checked", row_r45[column_r15.buttonConfig.checkedParam] === true || row_r45[column_r15.buttonConfig.checkedParam] === "true" || row_r45[column_r15.buttonConfig.checkedParam] == 1)("disabled", row_r45[column_r15.buttonConfig.disabledParam]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r15.buttonConfig.title, " ");
} }
const _c4 = function (a0, a1, a2) { return { "rb-fixed-button-column": a0, "rb-float-button-column": a1, "rb-crud-drag-active": a2 }; };
function CrudComponent_ng_container_11_div_4_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 48);
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_4_td_2_button_1_Template, 3, 6, "button", 49);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_4_td_2_button_2_Template, 5, 7, "button", 50);
    ɵngcc0.ɵɵtemplate(3, CrudComponent_ng_container_11_div_4_td_2_mat_slide_toggle_3_Template, 3, 8, "mat-slide-toggle", 51);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r43 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(4, _c4, column_r15.buttonConfig.isFixed, !column_r15.buttonConfig.isFixed, ctx_r43.isDrag));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r15.isMenuButton && !column_r15.isToggleButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.isMenuButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.isToggleButton);
} }
function CrudComponent_ng_container_11_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_4_th_1_Template, 2, 5, "th", 45);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_4_td_2_Template, 4, 8, "td", 46);
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 29);
    ɵngcc0.ɵɵtemplate(1, CrudComponent_ng_container_11_div_1_Template, 3, 0, "div", 30);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_ng_container_11_div_2_Template, 3, 0, "div", 30);
    ɵngcc0.ɵɵtemplate(3, CrudComponent_ng_container_11_div_3_Template, 3, 0, "div", 30);
    ɵngcc0.ɵɵtemplate(4, CrudComponent_ng_container_11_div_4_Template, 3, 0, "div", 30);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r15 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("matColumnDef", column_r15.columnDef)("sticky", column_r15.isFixedColumn && ctx_r4.screenWidth >= ctx_r4.minWidthScreenToSticky)("stickyEnd", column_r15.isFixedColumnEnd && ctx_r4.screenWidth >= ctx_r4.minWidthScreenToSticky);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r15.isCheckBox && !column_r15.isButton && !column_r15.isDragDrop);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.isDragDrop);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.isCheckBox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r15.isButton);
} }
function CrudComponent_tr_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 58);
} }
const _c5 = function (a0, a1) { return { isVisible: a0, "rb-crud-drag-cursor": a1 }; };
function CrudComponent_tr_13_Template(rf, ctx) { if (rf & 1) {
    const _r77 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 59);
    ɵngcc0.ɵɵlistener("cdkDragStarted", function CrudComponent_tr_13_Template_tr_cdkDragStarted_0_listener() { ɵngcc0.ɵɵrestoreView(_r77); const ctx_r76 = ɵngcc0.ɵɵnextContext(); return ctx_r76.dragStarted(); })("cdkDragEnded", function CrudComponent_tr_13_Template_tr_cdkDragEnded_0_listener() { ɵngcc0.ɵɵrestoreView(_r77); const ctx_r78 = ɵngcc0.ɵɵnextContext(); return ctx_r78.dragEnded(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r75 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c5, row_r75.id && row_r75.id === ctx_r6.selectedLineId, ctx_r6.dragDrop))("cdkDragData", row_r75)("cdkDragDisabled", !ctx_r6.isDraggableTable || ctx_r6.verifyIsDraggableRow(row_r75));
} }
function CrudComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 60);
    ɵngcc0.ɵɵelementStart(1, "p", 61);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.msgCrudEmpty);
} }
function CrudComponent_button_18_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r79 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r79.icon);
} }
function CrudComponent_button_18_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 63);
    ɵngcc0.ɵɵelement(2, "path", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_button_18_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 64);
    ɵngcc0.ɵɵelement(2, "path", 65);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CrudComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r85 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 62);
    ɵngcc0.ɵɵlistener("click", function CrudComponent_button_18_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r85); const item_r79 = ctx.$implicit; const ctx_r84 = ɵngcc0.ɵɵnextContext(); return item_r79.action(ctx_r84.selectedLineMenu, ctx_r84.parentScope); });
    ɵngcc0.ɵɵtemplate(1, CrudComponent_button_18_mat_icon_1_Template, 2, 1, "mat-icon", 30);
    ɵngcc0.ɵɵtemplate(2, CrudComponent_button_18_mat_icon_2_Template, 3, 0, "mat-icon", 30);
    ɵngcc0.ɵɵtemplate(3, CrudComponent_button_18_mat_icon_3_Template, 3, 0, "mat-icon", 30);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r79 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.selectedLineMenu[item_r79.disabledParam]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r79.icon !== "rbLinkIcon" && item_r79.icon !== "rbDoubleIcon");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r79.icon === "rbLinkIcon");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r79.icon === "rbDoubleIcon");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r79.title);
} }
const _c6 = function (a0) { return { "rbHideCrudPaginator": a0 }; };
const _c7 = function (a0) { return { "max-width": a0 }; };
const _c8 = function (a0) { return { "rb-crud-table-active": a0 }; };
function ColorPaletteGeneratorComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵtext(1, "Escolha uma cor");
    ɵngcc0.ɵɵelementEnd();
} }
function ColorPaletteGeneratorComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 17);
} }
function ColorPaletteGeneratorComponent_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18, 19);
    ɵngcc0.ɵɵlistener("click", function ColorPaletteGeneratorComponent_a_9_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.toggle = !ctx_r13.toggle; });
    ɵngcc0.ɵɵelementStart(2, "mat-icon");
    ɵngcc0.ɵɵtext(3, "edit");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, " Editar ");
    ɵngcc0.ɵɵelementEnd();
} }
function ColorPaletteGeneratorComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 17);
} }
function ColorPaletteGeneratorComponent_a_11_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 20);
    ɵngcc0.ɵɵlistener("click", function ColorPaletteGeneratorComponent_a_11_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.showPalette(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("matTooltip", ctx_r5.displayedPalette ? "Esconder paleta de cores" : "Exibir paleta de cores");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.displayedPalette ? "visibility" : "visibility_off");
} }
function ColorPaletteGeneratorComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 17);
} }
function ColorPaletteGeneratorComponent_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 21);
    ɵngcc0.ɵɵlistener("click", function ColorPaletteGeneratorComponent_a_13_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.refreshColor(ctx_r17.colorBaseBackup); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "refresh");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ColorPaletteGeneratorComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 17);
} }
function ColorPaletteGeneratorComponent_a_15_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 22);
    ɵngcc0.ɵɵlistener("click", function ColorPaletteGeneratorComponent_a_15_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.showPaletteCode(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ColorPaletteGeneratorComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵelementStart(2, "div", 25);
    ɵngcc0.ɵɵelement(3, "p", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("fxFlex", ctx_r10.fxFlexRight);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r10.textInfo, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c9 = function (a0, a1) { return { "rb-dark-contrast-color": a0, "rb-light-contrast-color": a1 }; };
const _c10 = function (a0) { return { "background-color": a0 }; };
function ColorPaletteGeneratorComponent_mat_list_19_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list-item", 29);
    ɵngcc0.ɵɵelementStart(1, "span", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 31);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r22 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c9, color_r22.darkContrast, !color_r22.darkContrast))("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c10, color_r22.hex));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(color_r22.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(color_r22.hex);
} }
function ColorPaletteGeneratorComponent_mat_list_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list", 27);
    ɵngcc0.ɵɵtemplate(1, ColorPaletteGeneratorComponent_mat_list_19_mat_list_item_1_Template, 5, 9, "mat-list-item", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.paletteSettings.colors);
} }
const _c11 = function (a0) { return { "RbColorPickerSelectorDisable": a0 }; };
const _c12 = function (a0, a1) { return [a0, a1]; };
class CrudService {
    /**
     * @param {?} route
     * @param {?} router
     */
    constructor(route, router) {
        this.route = route;
        this.router = router;
        this.statusFilterDefault = new BehaviorSubject(false);
        this.currentStatusFilter = this.statusFilterDefault.asObservable();
        this.statusInfoCrudDefault = new BehaviorSubject(false);
        this.currentStatusInfoCrud = this.statusInfoCrudDefault.asObservable();
    }
    /**
     * @param {?} parameter e
     * @param {?=} column
     * @param {?=} dados
     * @return {?}
     */
    changeStatusFilter(parameter, column, dados) {
        this.currentStatusFilter.subscribe((/**
         * @param {?} d
         * @return {?}
         */
        d => this.statusFilter = d));
        this.statusFilterDefault.next(parameter);
        if (parameter === true && typeof column !== 'undefined' && typeof dados !== 'undefined') {
            return this.buildFilter(column, dados);
        }
    }
    /**
     * @param {?} dataSource
     * @param {?} receivedData
     * @param {?} table
     * @param {?} paginator
     * @param {?} sort
     * @return {?}
     */
    rowsCrud(dataSource, receivedData, table, paginator, sort) {
        this.dataSource = dataSource;
        this.receivedData = receivedData;
        this.table = table;
        this.paginator = paginator;
        this.sort = sort;
        this.refreshTable();
    }
    /**
     * @param {?} rowObj
     * @return {?}
     */
    addRowData(rowObj) {
        if (Array.isArray(rowObj) && typeof this.dataSource.data !== 'undefined') {
            /** @type {?} */
            const array = this.dataSource.data;
            Array.prototype.push.apply(array, rowObj);
            this.table.renderRows();
            this.refreshTable();
            if (this.paginator) {
                this.paginator.length = array.length;
            }
            this.dataSource.sort = this.sort;
        }
        else if (Array.isArray(rowObj) && typeof this.dataSource.data === 'undefined') {
            /** @type {?} */
            const array = this.dataSource;
            Array.prototype.push.apply(array, rowObj);
            this.table.renderRows();
            this.refreshTable();
            if (this.paginator) {
                this.paginator.length = array.length;
            }
            this.dataSource.sort = this.sort;
        }
        else if (typeof this.dataSource.data === 'undefined') {
            /** @type {?} */
            const array = this.dataSource;
            array.push(rowObj);
            this.table.renderRows();
            this.refreshTable();
            if (this.paginator) {
                this.paginator.length = array.length;
            }
            this.dataSource.sort = this.sort;
        }
        else {
            /** @type {?} */
            const array = this.dataSource.data;
            array.push(rowObj);
            this.table.renderRows();
            this.refreshTable();
            if (this.paginator) {
                this.paginator.length = array.length;
            }
            this.dataSource.sort = this.sort;
        }
    }
    /**
     * @param {?} rowObj
     * @return {?}
     */
    updateRowData(rowObj) {
        this.dataSource.data = this.dataSource.data.filter((/**
         * @param {?} value
         * @param {?} key
         * @return {?}
         */
        (value, key) => {
            if (value.id === rowObj.id) {
                // tslint:disable-next-line: forin
                for (const index in rowObj) {
                    value[index] = rowObj[index];
                }
            }
            return true;
        }));
        this.table.renderRows();
        this.dataSource.sort = this.sort;
    }
    /**
     * @param {?} rowObj
     * @return {?}
     */
    deleteRowData(rowObj) {
        if (typeof this.dataSource.data === 'undefined') {
            /** @type {?} */
            const array = this.receivedData;
            /** @type {?} */
            const result = this.arrayRemove(array, Number(rowObj));
            this.receivedData = result;
            this.table.renderRows();
            if (this.paginator) {
                this.paginator.length = result.length;
            }
            this.dataSource.sort = this.sort;
        }
        else {
            /** @type {?} */
            const array = this.dataSource.data;
            /** @type {?} */
            const result = this.arrayRemove(array, Number(rowObj));
            this.dataSource.data = result;
            this.table.renderRows();
            if (this.paginator) {
                this.paginator.length = result.length;
            }
            this.dataSource.sort = this.sort;
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    rowChange(obj) {
        return obj;
    }
    /**
     * @private
     * @return {?}
     */
    refreshTable() {
        if (this.paginator) {
            this.paginator._changePageSize(this.paginator.pageSize);
        }
    }
    /**
     * @private
     * @param {?} arr
     * @param {?} value
     * @return {?}
     */
    arrayRemove(arr, value) {
        return arr.filter((/**
         * @param {?} ele
         * @return {?}
         */
        (ele) => {
            return ele.id !== value;
        }));
    }
    // public setRowChecked(params) {
    //   this.valueChecked.next(params);
    // }
    // public getRowCheck(): Observable<any> {
    //   return this.valueChecked.asObservable();
    // }
    /**
     * @param {?} selection
     * @return {?}
     */
    getSelection(selection) {
        this.selection = selection;
        return selection;
    }
    /**
     * @param {?} dataSource
     * @return {?}
     */
    isAllSelected(dataSource) {
        /** @type {?} */
        const numSelected = this.selection.selected.length;
        /** @type {?} */
        const numRows = dataSource.length;
        return numSelected === numRows;
    }
    /**
     * @param {?} $event
     * @param {?} dataRow
     * @param {?} array
     * @param {?} dataSource
     * @return {?}
     */
    getRowChecked($event, dataRow, array, dataSource) {
        if (this.isAllSelected(dataSource.fakeData)) {
            array = dataSource.fakeData;
        }
        else if ($event.checked) {
            array.push(dataRow);
        }
        else if ($event.checked === false && typeof dataRow !== 'undefined') {
            array = array.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => item !== dataRow));
        }
        else {
            array = [];
        }
        // setTimeout(() => {
        //   this.setRowChecked(array);
        // });
        return array;
    }
    /**
     * @private
     * @param {?} column
     * @param {?} dados
     * @return {?}
     */
    buildFilter(column, dados) {
        // const reduced = dados.reduce(function (filtered, colum) {
        //   if (column) {
        //     const someNewValue = { coluna: column, newProperty: 'Foo' };
        //     filtered.push(someNewValue);
        //   }
        //   return filtered;
        // }, []);
        // const reduced = dados.reduce(function (filtered, colum) {
        //   if (column) {
        //     const someNewValue = { coluna: column, newProperty: 'Foo' };
        //     filtered.push(someNewValue);
        //   }
        //   return filtered;
        // }, []);
        /** @type {?} */
        const filtered = [];
        // tslint:disable-next-line: forin
        for (const key in column) {
            // console.log(column[key]);
            /** @type {?} */
            const p = column[key];
            // tslint:disable-next-line: forin
            for (const keyy in dados) {
                /** @type {?} */
                const op = dados[keyy][p];
                // console.log(p + '--', dados[keyy][p]);
            }
            // tslint:disable-next-line: no-shadowed-variable
            // const aa = dados.filter((s => () => !s.has(column[key]) && s.add(column[key]))(new Set));
            // console.log(aa);
        }
        /** @type {?} */
        const pp = column[0];
        // tslint:disable-next-line: no-shadowed-variable
        // const aa = dados.filter((s => () => !s.has(pp) && s.add(pp))(new Set));
        // console.log(aa);
    }
}
CrudService.ɵfac = function CrudService_Factory(t) { return new (t || CrudService)(ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
CrudService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CrudService, factory: CrudService.ɵfac, providedIn: 'root' });
/** @nocollapse */
CrudService.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router }
];
/** @nocollapse */ CrudService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CrudService_Factory() { return new CrudService(ɵɵinject(ActivatedRoute), ɵɵinject(Router)); }, token: CrudService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }]; }, null); })();
if (false) {
    /** @type {?} */
    CrudService.prototype.statusFilterDefault;
    /** @type {?} */
    CrudService.prototype.currentStatusFilter;
    /** @type {?} */
    CrudService.prototype.statusFilter;
    /** @type {?} */
    CrudService.prototype.statusInfoCrudDefault;
    /** @type {?} */
    CrudService.prototype.currentStatusInfoCrud;
    /** @type {?} */
    CrudService.prototype.statusInfoCrud;
    /** @type {?} */
    CrudService.prototype.textInfoCrud;
    /** @type {?} */
    CrudService.prototype.dataSource;
    /** @type {?} */
    CrudService.prototype.receivedData;
    /** @type {?} */
    CrudService.prototype.table;
    /** @type {?} */
    CrudService.prototype.paginator;
    /** @type {?} */
    CrudService.prototype.sort;
    /** @type {?} */
    CrudService.prototype.selection;
    /**
     * @type {?}
     * @private
     */
    CrudService.prototype.route;
    /**
     * @type {?}
     * @private
     */
    CrudService.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CrudComponent {
    /**
     * @param {?} crudService
     */
    constructor(crudService) {
        this.crudService = crudService;
        this.columns = [];
        this.pageSizeOptions = [5, 10, 25, 50, 100, 200];
        this.initializePageSizeOptions = 10;
        this.clickedButtonEdit = new EventEmitter();
        this.clickedButtonLink = new EventEmitter();
        this.clickedButtonDelete = new EventEmitter();
        this.pageEvent = new EventEmitter();
        this.selection = new SelectionModel(true, []);
        this.pageIndex = 0;
        this.selectedLineMenu = {};
        this.isDraggableTable = false;
        this.draggableDisableParam = '';
        // Status filter
        this.triggerFilter = false;
        this.displayFilter = crudService.statusFilter;
    }
    /**
     * @param {?} sort
     * @return {?}
     */
    set content(sort) {
        this.mSort = sort;
    }
    /**
     * @param {?=} event
     * @return {?}
     */
    getScreenWidth(event) {
        this.screenWidth = window.innerWidth;
        this.rbCrudContainerWidth = this.rbCrudContainer
            && this.rbCrudContainer.nativeElement
            && this.rbCrudContainer.nativeElement.offsetWidth ?
            this.rbCrudContainer.nativeElement.offsetWidth + 'px' : 'auto';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.verifyIsDraggableTable();
        this.getScreenWidth();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.dataSource.sort = this.mSort;
        this.crudService.rowsCrud(this.dataSource, this.receivedData, this.table, this.paginator, this.mSort);
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.columns !== undefined || this.columns !== null) {
            this.dataSource = new MatTableDataSource(this.receivedData);
            this.dataSource.filterPredicate = (/**
             * @param {?} data
             * @param {?} filter
             * @return {?}
             */
            (data, filter) => {
                /** @type {?} */
                const dataStr = Object.keys(data).reduce((/**
                 * @param {?} currentTerm
                 * @param {?} key
                 * @return {?}
                 */
                (currentTerm, key) => {
                    return (currentTerm + ((/** @type {?} */ (data)))[key] + '◬');
                }), '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                /** @type {?} */
                const transformedFilter = filter.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                return dataStr.indexOf(transformedFilter) != -1;
            });
            this.displayedColumns = this.columns.map((/**
             * @param {?} x
             * @return {?}
             */
            x => x.columnDef));
            if (this.noHasPaginator) {
                this.dataSource.paginator = null;
            }
            else if (this.paginator) {
                this.pageSize = this.noHasPaginator ? 200 : this.initializePageSizeOptions;
                this.dataSource.paginator = this.paginator;
                this.dataSource.paginator.pageSize = this.pageSize;
                this.dataSource.paginator.pageIndex = this.pageIndex;
                this.dataSource.paginator.length = this.metaCount;
            }
            this.crudService.rowsCrud(this.dataSource, this.receivedData, this.table, this.paginator, this.mSort);
        }
    }
    /**
     * @param {?} filterValue
     * @return {?}
     */
    applyFilter(filterValue) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        if (this.dataSource.paginator) {
            if (this.pageIndex) {
                this.dataSource.paginator.pageIndex = this.pageIndex - 1;
            }
            this.dataSource.paginator.firstPage();
        }
    }
    /**
     * @param {?} param
     * @return {?}
     */
    actionButtonEdit(param) {
        this.clickedButtonEdit.emit(param);
    }
    /**
     * @param {?} param
     * @return {?}
     */
    actionButtonLink(param) {
        this.clickedButtonLink.emit(param);
    }
    /**
     * @param {?} param
     * @return {?}
     */
    actionButtonDelete(param) {
        this.clickedButtonDelete.emit(param);
    }
    /**
     * @return {?}
     */
    activeFilter() {
        if (this.triggerFilter === false) {
            this.triggerFilter = true;
        }
        else {
            /** @type {?} */
            const getAttribute = document.getElementById('triggerFilter');
            getAttribute.classList.remove('scale-in-ver-top');
            getAttribute.classList.add('scale-out-ver-top');
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.triggerFilter = false;
            }), 250);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    updateProductsTable(event) {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1; // API starts 1, Mat-Table starts at 0
        this.pageEvent.emit(event);
    }
    /**
     * @param {?=} event
     * @return {?}
     */
    dropTable(event) {
        /** @type {?} */
        let disabledParam = null;
        if (this.columns && this.columns[0] && this.columns[0].disabledParam) {
            disabledParam = this.columns[0].disabledParam;
        }
        if (disabledParam) {
            /** @type {?} */
            const index = this.setIndexOrder(event);
            /** @type {?} */
            let blocked = false;
            if (this.dataSource && this.dataSource.data && this.dataSource.data.length) {
                for (let i = index.first; i <= index.last; i++) {
                    if (this.dataSource.data[i] && this.dataSource.data[i][disabledParam]) {
                        blocked = true;
                    }
                }
            }
            if (!blocked) {
                this.updateDrag(event);
            }
        }
        else {
            this.updateDrag(event);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setIndexOrder(event) {
        if (event.previousIndex < event.currentIndex) {
            return { first: event.previousIndex, last: event.currentIndex };
        }
        else {
            return { first: event.currentIndex, last: event.previousIndex };
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    updateDrag(event) {
        /** @type {?} */
        const prevIndex = this.dataSource.data.findIndex((/**
         * @param {?} d
         * @return {?}
         */
        (d) => d === event.item.data));
        moveItemInArray(this.dataSource.data, prevIndex, event.currentIndex);
        this.dataSource.data = this.dataSource.data;
        this.table.renderRows();
        if (this.dragAction && typeof this.dragAction === 'function') {
            this.dragAction(event, this.parentScope);
        }
    }
    /**
     * @return {?}
     */
    dragStarted() {
        this.isDrag = true;
    }
    /**
     * @return {?}
     */
    dragEnded() {
        this.isDrag = false;
    }
    /**
     * @return {?}
     */
    verifyIsDraggableTable() {
        if (this.columns && this.columns.length) {
            for (const item of this.columns) {
                if (item.isDragDrop) {
                    this.isDraggableTable = true;
                    this.draggableDisableParam = item.disabledParam;
                }
            }
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    verifyIsDraggableRow(row) {
        /** @type {?} */
        let response = false;
        if (row[this.draggableDisableParam]) {
            response = true;
        }
        return response;
    }
    /**
     * @return {?}
     */
    canDragDrop() {
        if (this.dragDrop === true || this.dragDrop === 'true' || typeof this.dragDrop === 'undefined') {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Whether the number of selected elements matches the total number of rows.
     * @return {?}
     */
    isAllSelected() {
        /** @type {?} */
        const numSelected = this.selection.selected.length;
        /** @type {?} */
        const numRows = this.dataSource.data.length;
        this.crudService.getSelection(this.selection);
        return numSelected === numRows;
    }
    /**
     * Selects all rows if they are not all selected; otherwise clear selection.
     * @return {?}
     */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach((/**
             * @param {?} row
             * @return {?}
             */
            row => this.selection.select(row)));
    }
    /**
     * The label for the checkbox on the passed row
     * @param {?=} row
     * @return {?}
     */
    checkboxLabel(row) {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.crudService.statusFilterDefault.next(false);
    }
    /**
     * @param {?} row
     * @return {?}
     */
    saveSelectedLineMenu(row) {
        this.selectedLineMenu = row;
        this.selectedLineId = row.id;
        // console.log('this.selectedLineMenu', this.selectedLineMenu);
    }
}
CrudComponent.ɵfac = function CrudComponent_Factory(t) { return new (t || CrudComponent)(ɵngcc0.ɵɵdirectiveInject(CrudService)); };
CrudComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CrudComponent, selectors: [["rb-crud"]], viewQuery: function CrudComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatSort, true);
        ɵngcc0.ɵɵviewQuery(MatTable, true);
        ɵngcc0.ɵɵstaticViewQuery(MatPaginator, true);
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rbCrudContainer = _t.first);
    } }, hostBindings: function CrudComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function CrudComponent_resize_HostBindingHandler($event) { return ctx.getScreenWidth($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { columns: "columns", pageSizeOptions: "pageSizeOptions", initializePageSizeOptions: "initializePageSizeOptions", displayedColumns: "displayedColumns", receivedData: "receivedData", descCrudEmpty: "descCrudEmpty", metaCount: "metaCount", msgCrudEmpty: "msgCrudEmpty", menuOptions: "menuOptions", parentScope: "parentScope", dragDrop: "dragDrop", dragAction: "dragAction", disableSort: "disableSort", noHasPaginator: "noHasPaginator", noHasSearch: "noHasSearch", minWidthScreenToSticky: "minWidthScreenToSticky" }, outputs: { clickedButtonEdit: "clickedButtonEdit", clickedButtonLink: "clickedButtonLink", clickedButtonDelete: "clickedButtonDelete", pageEvent: "pageEvent" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 19, vars: 26, consts: [["id", "rb-crud-container", 1, "rb-crud-container"], ["rbCrudContainer", ""], ["fxLayout", "row wrap", "fxLayoutAlign", "start end", 1, "ps-crud-header"], ["fxFlex.xs", "100", "fxFlexOrder.xs", "2", "fxLayoutAlign", "start center", "class", "rb-crud-search-container", "style", "max-height: 68px;", 4, "ngIf"], ["fxFlex", ""], ["fxFlex.xs", "100", "fxFlexOrder.xs", "1", "fxLayoutAlign", "end center", "fxLayoutAlign.xs", "start center", 1, "rb-crud-search-container", 3, "hidden", "ngClass"], [3, "pageSizeOptions", "length", "disabled", "page"], ["fxLayout", "row", "class", "ps-crud-content-filter scale-in-ver-top", "id", "triggerFilter", 4, "ngIf"], [1, "rb-crud-sticky-container", 3, "hidden", "ngStyle"], ["mat-table", "", "matSort", "", "cdkDropList", "", 1, "ps-crud-table", 3, "matSortDisabled", "dataSource", "ngClass", "cdkDropListDisabled", "cdkDropListData", "cdkDragStarted", "cdkDropListDropped"], ["table", ""], [3, "matColumnDef", "sticky", "stickyEnd", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "cdkDragLockAxis", "y", "cdkDrag", "", 3, "ngClass", "cdkDragData", "cdkDragDisabled", "cdkDragStarted", "cdkDragEnded", 4, "matRowDef", "matRowDefColumns"], ["class", "rbMsgCrudEmptyContainer", 4, "ngIf"], ["fxLayout", "row", "id", "menuOptions"], [1, "rbCrudMenu"], ["rbCrudMenu", "matMenu"], ["mat-menu-item", "", 3, "disabled", "click", 4, "ngFor", "ngForOf"], ["fxFlex.xs", "100", "fxFlexOrder.xs", "2", "fxLayoutAlign", "start center", 1, "rb-crud-search-container", 2, "max-height", "68px"], ["floatLabel", "never", 1, "ps-crud-input-pesq"], ["matPrefix", "", 1, "rb-crud-search-icon"], ["matInput", "", "placeholder", "Pesquisar", 1, "rb-crud-search-input", 3, "keyup"], ["class", "ps-crud-button-filter", 3, "click", 4, "ngIf"], [1, "ps-crud-button-filter", 3, "click"], [1, "ps-crud-button-icon-filter"], ["width", "16", "height", "15", "viewBox", "0 0 16 15", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M14.7537 0.631958H1.16146C0.536911 0.631958 0.221764 1.33923 0.664294 1.75226L6.08252 6.81003V12.4445C6.08252 12.6586 6.19446 12.8593 6.38243 12.9821L8.72618 14.5128C9.18857 14.8149 9.83252 14.5087 9.83252 13.9752V6.81003L15.2509 1.75226C15.6925 1.34005 15.3795 0.631958 14.7537 0.631958Z", "fill", "#808080"], ["fxLayout", "row", "id", "triggerFilter", 1, "ps-crud-content-filter", "scale-in-ver-top"], [3, "matColumnDef", "sticky", "stickyEnd"], [4, "ngIf"], ["mat-header-cell", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "rb-crud-simple-text-col", 3, "cursor", "click", 4, "matCellDef"], ["mat-header-cell", "", "mat-sort-header", ""], ["mat-cell", "", 1, "rb-crud-simple-text-col", 3, "click"], [3, "ngClass"], ["mat-header-cell", "", "class", "rb-drag-indicator-column", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", "", 1, "rb-drag-indicator-column"], ["mat-cell", ""], ["cdkDragHandle", "", 2, "pointer-events", "all"], ["mat-header-cell", "", "class", "rb-checkbox-column", 4, "matHeaderCellDef"], ["mat-header-cell", "", 1, "rb-checkbox-column"], ["color", "primary", 3, "checked", "indeterminate", "aria-label", "disabled", "change"], ["color", "primary", 3, "checked", "aria-label", "disabled", "click", "change"], ["mat-header-cell", "", 3, "ngClass", 4, "matHeaderCellDef"], ["td", "", "mat-cell", "", "class", "ps-crud-content-button", 3, "ngClass", 4, "matCellDef"], ["mat-header-cell", "", 3, "ngClass"], ["td", "", "mat-cell", "", 1, "ps-crud-content-button", 3, "ngClass"], ["mat-button", "", "class", "ps-crud-button-tr ps-crud-button-link", "id", "column.dataName(row)", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["mat-button", "", "class", "ps-crud-button-tr rbCrudMenuButton", "id", "column.dataName(row)", 3, "ngClass", "matMenuTriggerFor", "matMenuTriggerData", "disabled", "menuOpened", "menuClosed", 4, "ngIf"], ["class", "ps-crud-toggle", "color", "primary", 3, "matTooltip", "matTooltipDisabled", "ngClass", "checked", "disabled", "dragChange", "toggleChange", 4, "ngIf"], ["mat-button", "", "id", "column.dataName(row)", 1, "ps-crud-button-tr", "ps-crud-button-link", 3, "ngClass", "disabled", "click"], ["width", "18", "height", "14", "viewBox", "0 0 15 15", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M13.7828 0.861203C13.2563 0.334626 12.6221 0.0712891 11.8804 0.0712891H2.90537C2.16376 0.0712891 1.52948 0.334626 1.00281 0.861203C0.476228 1.38788 0.212891 2.02212 0.212891 2.76377V11.7387C0.212891 12.4803 0.476228 13.1146 1.00281 13.6413C1.52948 14.168 2.16376 14.4313 2.90537 14.4313H11.8803C12.622 14.4313 13.2562 14.168 13.7827 13.6413C14.3094 13.1146 14.5727 12.4803 14.5727 11.7387V2.76377C14.5727 2.02212 14.3093 1.38778 13.7828 0.861203ZM12.1795 7.55037C12.1795 7.81213 12.0578 7.9959 11.8149 8.10193C11.734 8.13307 11.6558 8.14866 11.5811 8.14866C11.413 8.14866 11.2727 8.08936 11.1604 7.97105L9.81428 6.62482L4.82215 11.6172C4.70358 11.7356 4.56347 11.7949 4.40138 11.7949C4.23922 11.7949 4.09897 11.7356 3.98057 11.6172L3.02699 10.6635C2.90855 10.5453 2.84931 10.4048 2.84931 10.2428C2.84931 10.0809 2.90855 9.94061 3.02699 9.82227L8.01941 4.8298L6.67315 3.48357C6.47989 3.30282 6.4363 3.0848 6.5422 2.82916C6.6481 2.58616 6.83206 2.46451 7.09383 2.46451H11.5811C11.7432 2.46451 11.8835 2.52378 12.0021 2.64225C12.1204 2.76059 12.1796 2.90087 12.1796 3.06293V7.55037H12.1795Z", "fill", "#979797"], ["mat-button", "", "id", "column.dataName(row)", 1, "ps-crud-button-tr", "rbCrudMenuButton", 3, "ngClass", "matMenuTriggerFor", "matMenuTriggerData", "disabled", "menuOpened", "menuClosed"], ["color", "primary", 1, "ps-crud-toggle", 3, "matTooltip", "matTooltipDisabled", "ngClass", "checked", "disabled", "dragChange", "toggleChange"], ["toggleButton", ""], ["mat-header-row", ""], ["mat-row", "", "cdkDragLockAxis", "y", "cdkDrag", "", 3, "ngClass", "cdkDragData", "cdkDragDisabled", "cdkDragStarted", "cdkDragEnded"], [1, "rbMsgCrudEmptyContainer"], [2, "text-align", "center"], ["mat-menu-item", "", 3, "disabled", "click"], ["width", "15", "height", "15", "viewBox", "0 0 15 15", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["width", "14", "height", "14", "viewBox", "0 0 14 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M12.6816 0.399902C13.3547 0.399902 13.9004 0.945547 13.9004 1.61865V8.93115C13.9004 9.60426 13.3547 10.1499 12.6816 10.1499H5.36914C4.69604 10.1499 4.15039 9.60426 4.15039 8.93115V1.61865C4.15039 0.945547 4.69604 0.399902 5.36914 0.399902H12.6816ZM5.36914 10.9624C4.24911 10.9624 3.33789 10.0512 3.33789 8.93115V3.6499H2.11914C1.44604 3.6499 0.900391 4.19555 0.900391 4.86865V12.1812C0.900391 12.8543 1.44604 13.3999 2.11914 13.3999H9.43164C10.1047 13.3999 10.6504 12.8543 10.6504 12.1812V10.9624H5.36914Z", "fill", "black", "fill-opacity", "0.87"]], template: function CrudComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, CrudComponent_div_3_Template, 6, 1, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "mat-paginator", 6);
        ɵngcc0.ɵɵlistener("page", function CrudComponent_Template_mat_paginator_page_6_listener($event) { return ctx.updateProductsTable($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, CrudComponent_div_7_Template, 1, 0, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵelementStart(9, "table", 9, 10);
        ɵngcc0.ɵɵlistener("cdkDragStarted", function CrudComponent_Template_table_cdkDragStarted_9_listener() { return ctx.dragStarted(); })("cdkDropListDropped", function CrudComponent_Template_table_cdkDropListDropped_9_listener($event) { return ctx.dropTable($event); });
        ɵngcc0.ɵɵtemplate(11, CrudComponent_ng_container_11_Template, 5, 7, "ng-container", 11);
        ɵngcc0.ɵɵtemplate(12, CrudComponent_tr_12_Template, 1, 0, "tr", 12);
        ɵngcc0.ɵɵtemplate(13, CrudComponent_tr_13_Template, 1, 6, "tr", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, CrudComponent_div_14_Template, 3, 1, "div", 14);
        ɵngcc0.ɵɵelementStart(15, "div", 15);
        ɵngcc0.ɵɵelementStart(16, "mat-menu", 16, 17);
        ɵngcc0.ɵɵtemplate(18, CrudComponent_button_18_Template, 6, 5, "button", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.noHasSearch !== true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.noHasPaginator)("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c6, ctx.noHasPaginator));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("pageSizeOptions", ctx.pageSizeOptions)("length", ctx.length)("disabled", ctx.noHasPaginator);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.triggerFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.dataSource || !ctx.dataSource.filteredData || !ctx.dataSource.filteredData.length)("ngStyle", ɵngcc0.ɵɵpureFunction1(22, _c7, ctx.rbCrudContainerWidth));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matSortDisabled", ctx.disableSort)("dataSource", ctx.dataSource)("ngClass", ɵngcc0.ɵɵpureFunction1(24, _c8, ctx.isDrag))("cdkDropListDisabled", ctx.canDragDrop())("cdkDropListData", ctx.dataSource);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.columns)("ngForOf", ctx.index);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.dataSource || !ctx.dataSource.filteredData || !ctx.dataSource.filteredData.length);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menuOptions);
    } }, directives: [ɵngcc2.DefaultLayoutDirective, ɵngcc2.DefaultLayoutAlignDirective, ɵngcc3.NgIf, ɵngcc2.DefaultFlexDirective, ɵngcc2.DefaultFlexOrderDirective, ɵngcc3.NgClass, ɵngcc4.DefaultClassDirective, ɵngcc5.MatPaginator, ɵngcc3.NgStyle, ɵngcc4.DefaultStyleDirective, ɵngcc6.MatTable, ɵngcc7.MatSort, ɵngcc8.CdkDropList, ɵngcc3.NgForOf, ɵngcc6.MatHeaderRowDef, ɵngcc6.MatRowDef, ɵngcc9._MatMenu, ɵngcc7.MatFormField, ɵngcc10.MatIcon, ɵngcc7.MatPrefix, ɵngcc7.MatInput, ɵngcc11.MatButtonToggle, ɵngcc6.MatColumnDef, ɵngcc6.MatHeaderCellDef, ɵngcc6.MatCellDef, ɵngcc6.MatHeaderCell, ɵngcc7.MatSortHeader, ɵngcc6.MatCell, ɵngcc8.CdkDragHandle, ɵngcc12.MatCheckbox, ɵngcc13.MatButton, ɵngcc9.MatMenuTrigger, ɵngcc14.MatSlideToggle, ɵngcc15.MatTooltip, ɵngcc6.MatHeaderRow, ɵngcc6.MatRow, ɵngcc8.CdkDrag, ɵngcc9.MatMenuItem], styles: ["table[_ngcontent-%COMP%]{width:100%}.rb-text-decoration-action[_ngcontent-%COMP%]{transition:.3s}.rb-text-decoration-action[_ngcontent-%COMP%]:hover{text-decoration:underline}.mat-column-select[_ngcontent-%COMP%]{overflow:initial}.ps-crud-button-filter[_ngcontent-%COMP%]{border-radius:50%!important;height:32px;width:32px;border:none;margin-left:5px}.ps-crud-button-filter[_ngcontent-%COMP%]   .ps-crud-button-icon-filter[_ngcontent-%COMP%]{height:15px;width:15px}.rb-crud-sticky-container[_ngcontent-%COMP%]{overflow:auto}.rbMsgCrudEmptyContainer[_ngcontent-%COMP%]{padding:20px;background-color:#fff}  .mat-button-toggle-appearance-standard .mat-button-toggle-label-content{padding:0!important;line-height:32px!important}  .mat-button-toggle-checked.mat-button-toggle-appearance-standard{background:#f3f3f3;box-shadow:inset 0 4px 4px 0 rgba(0,0,0,.09)}  .ps-crud-input-pesq .mat-form-field-prefix{line-height:1.025}  .ps-crud-input-pesq .mat-form-field-prefix .mat-icon{font-size:22px;line-height:1.025}  .ps-crud-input-pesq mat-icon{margin-right:10px;color:#757575}  .ps-crud-input-pesq input{padding:5px 0}  .ps-crud-input-pesq label{margin-top:5px}  .rb-crud-search-container{max-height:55px}  .rb-crud-search-container div.mat-form-field-prefix{top:2px}  .rb-crud-search-container .mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:16px}  .rb-crud-search-container mat-form-field.mat-form-field{line-height:22px}  mat-paginator.mat-paginator{width:100%}.ps-crud-header[_ngcontent-%COMP%]{padding:10px 24px;background-color:#fff}.ps-crud-content-filter[_ngcontent-%COMP%]{background:#f3f3f3;box-shadow:inset 0 4px 4px rgba(0,0,0,.06);padding:24px 24px 0}.ps-crud-content-button.rb-float-button[_ngcontent-%COMP%]{text-align:center;width:10px;padding:0 2px!important}.ps-crud-content-button.rb-float-button[_ngcontent-%COMP%]:last-child{padding-right:12px!important}td.ps-crud-content-button.mat-cell.rb-fixed-button-column[_ngcontent-%COMP%], th.mat-header-cell.rb-fixed-button-column[_ngcontent-%COMP%]{width:116px;max-width:116px;text-align:center;padding-right:10px;padding-left:10px}td.ps-crud-content-button.mat-cell.rb-float-button-column[_ngcontent-%COMP%], th.mat-header-cell.rb-float-button-column[_ngcontent-%COMP%]{text-align:center;width:10px;padding:0 2px!important}td.ps-crud-content-button.mat-cell.rb-float-button-column[_ngcontent-%COMP%]:last-child, th.mat-header-cell.rb-float-button-column[_ngcontent-%COMP%]:last-child{padding-right:12px!important}  th.mat-header-cell.cdk-column-check.mat-column-check{width:45px;max-width:45px;min-width:45px!important}  td.mat-cell.cdk-column-dragDrop.mat-column-dragDrop{width:30px;max-width:30px;min-width:30px!important}.rb-crud-table-active[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background:#fff;cursor:move}.ps-crud-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-weight:400;font-size:14px;color:#2d2d2d}.ps-crud-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{height:45px}.ps-crud-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-weight:400;font-size:14px;color:grey;padding-right:20px}.menu-active[_ngcontent-%COMP%]{background:rgba(196,196,196,.3)}.menu-active[_ngcontent-%COMP%]   button.rb-float-button[_ngcontent-%COMP%], .menu-active[_ngcontent-%COMP%]   mat-slide-toggle.rb-float-button[_ngcontent-%COMP%]{visibility:visible}  tbody tr:hover{background:#f1f1f1}  tbody tr:hover button.rb-float-button{visibility:visible}  tbody tr:hover mat-slide-toggle.rb-float-button{visibility:visible}  tbody tr button.rb-float-button{visibility:hidden}  tbody tr mat-slide-toggle.rb-float-button{visibility:hidden}  tbody tr.isVisible{background:#f1f1f1}  tbody tr.isVisible button.rb-float-button{visibility:visible!important}  tbody tr.isVisible mat-slide-toggle.rb-float-button{visibility:visible!important}  tbody tr.isVisible button.rbCrudMenuButton{background:#c4c4c4!important;color:#000}.ps-crud-toggle[_ngcontent-%COMP%]{margin-right:5px}.ps-crud-button-tr[_ngcontent-%COMP%]{min-width:25px;line-height:27px;padding:0;margin:0 auto}.ps-crud-button-tr[_ngcontent-%COMP%]:last-child{margin-right:5px}.ps-crud-button-tr[_ngcontent-%COMP%]:hover:not([disabled]){background:#c4c4c4!important}.ps-crud-button-tr[_ngcontent-%COMP%]:hover:not([disabled])   mat-icon[_ngcontent-%COMP%]{color:#000000de}.ps-crud-button-tr[_ngcontent-%COMP%]:disabled{opacity:.4}.ps-crud-button-tr[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;height:auto;width:auto;font-size:18px;color:#979797;margin:0 auto}  .ps-crud-button-tr .mat-button-wrapper{display:flex;justify-content:center;align-items:center;height:24px}  .ps-crud-button-link:hover:not([disabled]) mat-icon svg path{fill:#000000de}  .ps-crud-content-menu-button{text-align:center;width:175px}  .ps-crud-content-menu-button button{color:#000000de;font-size:14px}  .ps-crud-content-menu-button mat-icon{color:#000000de!important;height:18px;width:18px;line-height:16px;font-size:20px}.ps-crud-button-menu[_ngcontent-%COMP%]{padding:0 35px;background:#ffb946;color:#fff;margin-bottom:8px}.scale-in-ver-top[_ngcontent-%COMP%]{-webkit-animation:.3s cubic-bezier(.25,.46,.45,.94) both scale-in-ver-top;animation:.3s cubic-bezier(.25,.46,.45,.94) both scale-in-ver-top}  button.ps-crud-button-tr.rbCrudMenuButton{font-size:14px;font-weight:400;padding:0 0 0 4px;margin-right:0!important;color:#979797}  button.ps-crud-button-tr.rbCrudMenuButton:disabled{color:#979797}  button.ps-crud-button-tr.rbCrudMenuButton:hover:not([disabled]){color:#000}button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]   mat-icon.mat-icon[_ngcontent-%COMP%]{height:20px;width:16px;font-size:18px;margin-right:10px;line-height:16px}button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]:not([disabled]), button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]:not([disabled])   mat-icon.mat-icon[_ngcontent-%COMP%]{color:#000}button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]:not([disabled])   mat-icon.mat-icon[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#000}button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]:disabled{color:#979797;opacity:.5}button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]:disabled   mat-icon.mat-icon[_ngcontent-%COMP%]{color:#979797}button.mat-menu-item.ng-star-inserted[_ngcontent-%COMP%]:disabled   mat-icon.mat-icon[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#979797}@-webkit-keyframes scale-in-ver-top{0%{transform:scaleY(0);transform-origin:100% 0;opacity:1}100%{transform:scaleY(1);transform-origin:100% 0;opacity:1}}@keyframes scale-in-ver-top{0%{transform:scaleY(0);transform-origin:100% 0;opacity:1}100%{transform:scaleY(1);transform-origin:100% 0;opacity:1}}.scale-out-ver-top[_ngcontent-%COMP%]{-webkit-animation:.2s cubic-bezier(.55,.085,.68,.53) both scale-out-ver-top;animation:.2s cubic-bezier(.55,.085,.68,.53) both scale-out-ver-top}@-webkit-keyframes scale-out-ver-top{0%{transform:scaleY(1);transform-origin:100% 0;opacity:1}100%{transform:scaleY(0);transform-origin:100% 0;opacity:1}}@keyframes scale-out-ver-top{0%{transform:scaleY(1);transform-origin:100% 0;opacity:1}100%{transform:scaleY(0);transform-origin:100% 0;opacity:1}}tr.mat-row.cdk-drag[_ngcontent-%COMP%]:not(.cdk-drag-disabled){cursor:move}tr.mat-row.cdk-drag.cdk-drag-disabled[_ngcontent-%COMP%]   mat-icon.mat-icon.cdk-drag-handle[_ngcontent-%COMP%]{opacity:.3!important}.cdk-drag-preview[_ngcontent-%COMP%]{display:flex;width:100%;background:#fff;box-sizing:border-box;border-radius:4px;box-shadow:0 0 0 -3px rgba(0,0,0,.2),0 3px 6px 1px rgba(0,0,0,.14),0 3px 4px -2px rgba(0,0,0,.12)}.cdk-drag-preview[_ngcontent-%COMP%]   .mat-cell[_ngcontent-%COMP%]{display:flex;align-items:center;flex:1 1 100%;border-bottom-style:none}.cdk-drag-preview[_ngcontent-%COMP%]   .mat-cell[_ngcontent-%COMP%]   button[_ngcontent-%COMP%], .cdk-drag-preview[_ngcontent-%COMP%]   .mat-cell[_ngcontent-%COMP%]   mat-slide-toggle[_ngcontent-%COMP%]{visibility:hidden}.cdk-drag-preview[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]:first-of-type, .cdk-drag-preview[_ngcontent-%COMP%]   td.mat-footer-cell[_ngcontent-%COMP%]:first-of-type, .cdk-drag-preview[_ngcontent-%COMP%]   th.mat-header-cell[_ngcontent-%COMP%]:first-of-type{padding-left:24px}.cdk-drag-preview[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-weight:400;font-size:14px;color:grey;padding-right:20px}.cdk-drag-preview[_ngcontent-%COMP%]   td.mat-cell.cdk-column-dragDrop.mat-column-dragDrop[_ngcontent-%COMP%]{width:30px;max-width:30px}.cdk-drag-preview[_ngcontent-%COMP%]   td.ps-crud-content-button.mat-cell.rb-float-button-column[_ngcontent-%COMP%]{width:10px;max-width:10px}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform 150ms cubic-bezier(0,0,.2,1)}.ps-crud-table.cdk-drop-list-dragging[_ngcontent-%COMP%]   .mat-row[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform 250ms cubic-bezier(0,0,.2,1)}.rb-crud-drag-active[_ngcontent-%COMP%]   .rb-float-button[_ngcontent-%COMP%]{visibility:hidden}  .mat-paginator-container{justify-content:space-between!important}  .mat-paginator-range-label{margin:0!important}  .rbHideCrudPaginator{display:none!important}@media (max-widh:500px){.ps-crud-header[_ngcontent-%COMP%]   .mat-paginator-page-size[_ngcontent-%COMP%]{margin-right:auto}}"] });
/** @nocollapse */
CrudComponent.ctorParameters = () => [
    { type: CrudService }
];
CrudComponent.propDecorators = {
    displayedColumns: [{ type: Input }],
    receivedData: [{ type: Input }],
    descCrudEmpty: [{ type: Input }],
    columns: [{ type: Input }],
    metaCount: [{ type: Input }],
    msgCrudEmpty: [{ type: Input }],
    menuOptions: [{ type: Input }],
    parentScope: [{ type: Input }],
    dragDrop: [{ type: Input }],
    dragAction: [{ type: Input }],
    disableSort: [{ type: Input }],
    noHasPaginator: [{ type: Input }],
    noHasSearch: [{ type: Input }],
    minWidthScreenToSticky: [{ type: Input }],
    pageSizeOptions: [{ type: Input }],
    initializePageSizeOptions: [{ type: Input }],
    clickedButtonEdit: [{ type: Output }],
    clickedButtonLink: [{ type: Output }],
    clickedButtonDelete: [{ type: Output }],
    pageEvent: [{ type: Output }],
    table: [{ type: ViewChild, args: [MatTable, { static: false },] }],
    paginator: [{ type: ViewChild, args: [MatPaginator, { static: true },] }],
    content: [{ type: ViewChild, args: [MatSort, { static: false },] }],
    rbCrudContainer: [{ type: ViewChild, args: ['rbCrudContainer', { static: true },] }],
    getScreenWidth: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudComponent, [{
        type: Component,
        args: [{
                selector: 'rb-crud',
                template: "<div class=\"rb-crud-container\" id=\"rb-crud-container\" #rbCrudContainer>\n  <div fxLayout=\"row wrap\" fxLayoutAlign=\"start end\" class=\"ps-row\" class=\"ps-crud-header\">\n    <div fxFlex.xs=\"100\" fxFlexOrder.xs=\"2\" fxLayoutAlign=\"start center\"\n    *ngIf=\"noHasSearch!==true\"\n    class=\"rb-crud-search-container\"\n    style=\"max-height: 68px;\">\n      <mat-form-field floatLabel=\"never\" class=\"ps-crud-input-pesq\">\n        <mat-icon matPrefix class=\"rb-crud-search-icon\">search</mat-icon>\n        <input matInput\n        class=\"rb-crud-search-input\"\n        (keyup)=\"applyFilter($event.target.value)\"\n        placeholder=\"Pesquisar\">\n      </mat-form-field>\n      <mat-button-toggle class=\"ps-crud-button-filter\" (click)=\"activeFilter()\" *ngIf=\"displayFilter\">\n        <mat-icon class=\"ps-crud-button-icon-filter\">\n          <svg width=\"16\" height=\"15\" viewBox=\"0 0 16 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path\n              d=\"M14.7537 0.631958H1.16146C0.536911 0.631958 0.221764 1.33923 0.664294 1.75226L6.08252 6.81003V12.4445C6.08252 12.6586 6.19446 12.8593 6.38243 12.9821L8.72618 14.5128C9.18857 14.8149 9.83252 14.5087 9.83252 13.9752V6.81003L15.2509 1.75226C15.6925 1.34005 15.3795 0.631958 14.7537 0.631958Z\"\n              fill=\"#808080\" />\n          </svg>\n        </mat-icon>\n      </mat-button-toggle>\n    </div>\n    <div fxFlex=\"\"></div>\n    <div fxFlex.xs=\"100\" fxFlexOrder.xs=\"1\"\n    fxLayoutAlign=\"end center\" fxLayoutAlign.xs=\"start center\"\n    class=\"rb-crud-search-container\"\n    [hidden]=\"noHasPaginator\"\n    [ngClass]=\"{'rbHideCrudPaginator': noHasPaginator}\">\n      <mat-paginator\n      [pageSizeOptions]=\"pageSizeOptions\"\n      [length]=\"length\"\n      [disabled]=\"noHasPaginator\"\n      (page)=\"updateProductsTable($event)\">\n      </mat-paginator>\n    </div>\n  </div>\n\n  <div fxLayout=\"row\" class=\"ps-crud-content-filter scale-in-ver-top\" *ngIf=\"triggerFilter\" id=\"triggerFilter\">\n    <!-- <div fxFlex *ngFor=\"let column of columns\">\n      <mat-form-field>\n        <mat-label>{{column.header}}</mat-label>\n        <mat-select [(value)]=\"selected\">\n          <mat-option>None</mat-option>\n          <mat-option value=\"option1\">Option 1</mat-option>\n          <mat-option value=\"option2\">Option 2</mat-option>\n          <mat-option value=\"option3\">Option 3</mat-option>\n        </mat-select>\n      </mat-form-field>\n    </div> -->\n    <!-- <p>Ta em beta</p> -->\n  </div>\n  <!-- *ngIf=\"dataSource && dataSource.filteredData && dataSource.filteredData.length\" -->\n  <div class=\"rb-crud-sticky-container\"\n  [hidden]=\"!dataSource || !dataSource.filteredData || !dataSource.filteredData.length\"\n  [ngStyle]=\"{'max-width': rbCrudContainerWidth}\">\n    <table mat-table #table\n    matSort [matSortDisabled]=\"disableSort\"\n    [dataSource]=\"dataSource\" class=\"ps-crud-table\"\n    [ngClass]=\"{'rb-crud-table-active': isDrag}\"\n    [cdkDropListDisabled]=\"canDragDrop()\"\n    cdkDropList\n    (cdkDragStarted)=\"dragStarted()\"\n    [cdkDropListData]=\"dataSource\"\n    (cdkDropListDropped)=\"dropTable($event)\">\n      <ng-container *ngFor=\"let column of columns; let i of index\" [matColumnDef]=\"column.columnDef\"\n      [sticky]=\"column.isFixedColumn && screenWidth >= minWidthScreenToSticky\"\n      [stickyEnd]=\"column.isFixedColumnEnd && screenWidth >= minWidthScreenToSticky\">\n        <div\n          *ngIf=\"!column.isCheckBox && !column.isButton && !column.isDragDrop\">\n          <th mat-header-cell *matHeaderCellDef mat-sort-header>\n            {{column.header}}\n          </th>\n          <td\n            mat-cell\n            *matCellDef=\"let row\"\n            class=\"rb-crud-simple-text-col\"\n            [style.cursor]=\"column.action ? 'pointer': 'default'\"\n            (click)=\"column.action ? column.action(row, parentScope) : ''\">\n            <span [ngClass]=\"{'rb-text-decoration-action': column.action}\">\n              {{(column.dataName(row) && column.dataName(row)!=='' && column.dataName(row)!==null && column.dataName(row)!='undefined') ? column.dataName(row) : '--'}}\n            </span>\n          </td>\n        </div>\n\n\n        <div *ngIf=\"column.isDragDrop\">\n          <th mat-header-cell *matHeaderCellDef class=\"rb-drag-indicator-column\"></th>\n          <td mat-cell *matCellDef=\"let row\">\n            <mat-icon cdkDragHandle style=\"pointer-events:all;\">drag_indicator</mat-icon>\n          </td>\n        </div>\n\n        <div *ngIf=\"column.isCheckBox\">\n          <th mat-header-cell *matHeaderCellDef class=\"rb-checkbox-column\">\n            <mat-checkbox (change)=\"$event ? masterToggle() : null\" [checked]=\"selection.hasValue() && isAllSelected()\"\n              [indeterminate]=\"selection.hasValue() && !isAllSelected()\" [aria-label]=\"checkboxLabel()\"\n              color=\"primary\" [disabled]=\"column.disabledParam\">\n            </mat-checkbox>\n          </th>\n          <td mat-cell *matCellDef=\"let row\">\n            <mat-checkbox (click)=\"$event.stopPropagation()\" (change)=\"$event ? selection.toggle(row) : null\"\n              [checked]=\"selection.isSelected(row)\" [aria-label]=\"checkboxLabel(row)\" color=\"primary\"\n              [disabled]=\"row[column.disabledParam]\">\n            </mat-checkbox>\n          </td>\n        </div>\n\n        <div *ngIf=\"column.isButton\">\n          <th mat-header-cell *matHeaderCellDef [ngClass]=\"{'rb-fixed-button-column': column.buttonConfig.isFixed, 'rb-float-button-column': !column.buttonConfig.isFixed}\">\n            {{column.buttonConfig.isFixed && column.buttonConfig.header ? column.buttonConfig.header : ''}}\n          </th>\n          <td td mat-cell *matCellDef=\"let row\" class=\"ps-crud-content-button\" [ngClass]=\"{'rb-fixed-button-column': column.buttonConfig.isFixed, 'rb-float-button-column': !column.buttonConfig.isFixed, 'rb-crud-drag-active': isDrag}\">\n            <button *ngIf=\"!column.isMenuButton && !column.isToggleButton\"\n              mat-button\n              [ngClass]=\"{'rb-float-button': !column.buttonConfig.isFixed}\"\n              class=\"ps-crud-button-tr ps-crud-button-link\"\n              id=\"column.dataName(row)\"\n              [disabled]=\"row[column.buttonConfig.disabledParam]\"\n              (click)=\"column.buttonConfig.action(row, parentScope)\">\n              <mat-icon  *ngIf=\"column.buttonConfig.icon!=='rbLinkIcon'\">{{column.buttonConfig.icon}}</mat-icon>\n              <mat-icon *ngIf=\"column.buttonConfig.icon==='rbLinkIcon'\">\n                <svg width=\"18\" height=\"14\" viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path\n                    d=\"M13.7828 0.861203C13.2563 0.334626 12.6221 0.0712891 11.8804 0.0712891H2.90537C2.16376 0.0712891 1.52948 0.334626 1.00281 0.861203C0.476228 1.38788 0.212891 2.02212 0.212891 2.76377V11.7387C0.212891 12.4803 0.476228 13.1146 1.00281 13.6413C1.52948 14.168 2.16376 14.4313 2.90537 14.4313H11.8803C12.622 14.4313 13.2562 14.168 13.7827 13.6413C14.3094 13.1146 14.5727 12.4803 14.5727 11.7387V2.76377C14.5727 2.02212 14.3093 1.38778 13.7828 0.861203ZM12.1795 7.55037C12.1795 7.81213 12.0578 7.9959 11.8149 8.10193C11.734 8.13307 11.6558 8.14866 11.5811 8.14866C11.413 8.14866 11.2727 8.08936 11.1604 7.97105L9.81428 6.62482L4.82215 11.6172C4.70358 11.7356 4.56347 11.7949 4.40138 11.7949C4.23922 11.7949 4.09897 11.7356 3.98057 11.6172L3.02699 10.6635C2.90855 10.5453 2.84931 10.4048 2.84931 10.2428C2.84931 10.0809 2.90855 9.94061 3.02699 9.82227L8.01941 4.8298L6.67315 3.48357C6.47989 3.30282 6.4363 3.0848 6.5422 2.82916C6.6481 2.58616 6.83206 2.46451 7.09383 2.46451H11.5811C11.7432 2.46451 11.8835 2.52378 12.0021 2.64225C12.1204 2.76059 12.1796 2.90087 12.1796 3.06293V7.55037H12.1795Z\"\n                    fill=\"#979797\" />\n                </svg>\n              </mat-icon>\n            </button>\n\n            <button mat-button *ngIf=\"column.isMenuButton\"\n                [ngClass]=\"{'rb-float-button': !column.buttonConfig.isFixed}\"\n                [matMenuTriggerFor] = \"rbCrudMenu\"\n                [matMenuTriggerData] = \"row\"\n                [disabled]=\"row[column.buttonConfig.disabledParam]\"\n                (menuOpened)=\"saveSelectedLineMenu(row)\"\n                (menuClosed)=\"selectedLineId=null\"\n                class=\"ps-crud-button-tr rbCrudMenuButton\"\n                id=\"column.dataName(row)\">\n                <span>{{column.buttonConfig.title}}</span>\n                <mat-icon>arrow_drop_down</mat-icon>\n            </button>\n\n            <mat-slide-toggle #toggleButton *ngIf=\"column.isToggleButton\"\n              matTooltip=\"{{column.buttonConfig.subtitle}}\"\n              [matTooltipDisabled]=\"!row[column.buttonConfig.showSubtitleParam]\"\n              [ngClass]=\"{'rb-float-button': !column.buttonConfig.isFixed}\"\n              class=\"ps-crud-toggle\"\n              color=\"primary\"\n              (dragChange)=\"column.buttonConfig.action(column.dataName(row), parentScope, toggleButton.checked, toggleButton)\"\n              (toggleChange)=\"column.buttonConfig.action(column.dataName(row), parentScope, toggleButton.checked, toggleButton)\"\n              [checked]=\"row[column.buttonConfig.checkedParam]===true || row[column.buttonConfig.checkedParam]==='true' || row[column.buttonConfig.checkedParam]==1\"\n              [disabled]=\"row[column.buttonConfig.disabledParam]\">\n              {{column.buttonConfig.title}}\n            </mat-slide-toggle>\n          </td>\n        </div>\n\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n      <tr\n        mat-row *matRowDef=\"let row; columns: displayedColumns;\"\n        [ngClass]=\"{isVisible: (row.id && row.id === selectedLineId), 'rb-crud-drag-cursor': dragDrop}\"\n        cdkDragLockAxis=\"y\"\n        cdkDrag\n        [cdkDragData]=\"row\"\n        [cdkDragDisabled]=\"!isDraggableTable || verifyIsDraggableRow(row)\"\n        (cdkDragStarted)=\"dragStarted()\"\n        (cdkDragEnded)=\"dragEnded()\">\n      </tr>\n    </table>\n  </div>\n  <div *ngIf=\"!dataSource || !dataSource.filteredData || !dataSource.filteredData.length\"\n  class=\"rbMsgCrudEmptyContainer\">\n    <p style=\"text-align: center;\">{{ msgCrudEmpty }}</p>\n  </div>\n\n  <div fxLayout=\"row\" id=\"menuOptions\">\n      <mat-menu #rbCrudMenu=\"matMenu\" class=\"rbCrudMenu\">\n        <button mat-menu-item\n          *ngFor=\"let item of menuOptions\"\n          [disabled]=\"selectedLineMenu[item.disabledParam]\"\n          (click)=\"item.action(selectedLineMenu, parentScope)\">\n          <mat-icon *ngIf=\"item.icon!=='rbLinkIcon' && item.icon!=='rbDoubleIcon'\">{{item.icon}}</mat-icon>\n          <mat-icon *ngIf=\"item.icon==='rbLinkIcon'\">\n            <svg width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <path\n                d=\"M13.7828 0.861203C13.2563 0.334626 12.6221 0.0712891 11.8804 0.0712891H2.90537C2.16376 0.0712891 1.52948 0.334626 1.00281 0.861203C0.476228 1.38788 0.212891 2.02212 0.212891 2.76377V11.7387C0.212891 12.4803 0.476228 13.1146 1.00281 13.6413C1.52948 14.168 2.16376 14.4313 2.90537 14.4313H11.8803C12.622 14.4313 13.2562 14.168 13.7827 13.6413C14.3094 13.1146 14.5727 12.4803 14.5727 11.7387V2.76377C14.5727 2.02212 14.3093 1.38778 13.7828 0.861203ZM12.1795 7.55037C12.1795 7.81213 12.0578 7.9959 11.8149 8.10193C11.734 8.13307 11.6558 8.14866 11.5811 8.14866C11.413 8.14866 11.2727 8.08936 11.1604 7.97105L9.81428 6.62482L4.82215 11.6172C4.70358 11.7356 4.56347 11.7949 4.40138 11.7949C4.23922 11.7949 4.09897 11.7356 3.98057 11.6172L3.02699 10.6635C2.90855 10.5453 2.84931 10.4048 2.84931 10.2428C2.84931 10.0809 2.90855 9.94061 3.02699 9.82227L8.01941 4.8298L6.67315 3.48357C6.47989 3.30282 6.4363 3.0848 6.5422 2.82916C6.6481 2.58616 6.83206 2.46451 7.09383 2.46451H11.5811C11.7432 2.46451 11.8835 2.52378 12.0021 2.64225C12.1204 2.76059 12.1796 2.90087 12.1796 3.06293V7.55037H12.1795Z\"\n                fill=\"#979797\" />\n            </svg>\n          </mat-icon>\n          <mat-icon *ngIf=\"item.icon==='rbDoubleIcon'\">\n            <svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <path d=\"M12.6816 0.399902C13.3547 0.399902 13.9004 0.945547 13.9004 1.61865V8.93115C13.9004 9.60426 13.3547 10.1499 12.6816 10.1499H5.36914C4.69604 10.1499 4.15039 9.60426 4.15039 8.93115V1.61865C4.15039 0.945547 4.69604 0.399902 5.36914 0.399902H12.6816ZM5.36914 10.9624C4.24911 10.9624 3.33789 10.0512 3.33789 8.93115V3.6499H2.11914C1.44604 3.6499 0.900391 4.19555 0.900391 4.86865V12.1812C0.900391 12.8543 1.44604 13.3999 2.11914 13.3999H9.43164C10.1047 13.3999 10.6504 12.8543 10.6504 12.1812V10.9624H5.36914Z\" fill=\"black\" fill-opacity=\"0.87\"/>\n            </svg>\n          </mat-icon>\n          <span>{{item.title}}</span>\n        </button>\n      </mat-menu>\n  </div>\n</div>\n",
                styles: ["table{width:100%}.rb-text-decoration-action{transition:.3s}.rb-text-decoration-action:hover{text-decoration:underline}.mat-column-select{overflow:initial}.ps-crud-button-filter{border-radius:50%!important;height:32px;width:32px;border:none;margin-left:5px}.ps-crud-button-filter .ps-crud-button-icon-filter{height:15px;width:15px}.rb-crud-sticky-container{overflow:auto}.rbMsgCrudEmptyContainer{padding:20px;background-color:#fff}::ng-deep .mat-button-toggle-appearance-standard .mat-button-toggle-label-content{padding:0!important;line-height:32px!important}::ng-deep .mat-button-toggle-checked.mat-button-toggle-appearance-standard{background:#f3f3f3;box-shadow:inset 0 4px 4px 0 rgba(0,0,0,.09)}::ng-deep .ps-crud-input-pesq .mat-form-field-prefix{line-height:1.025}::ng-deep .ps-crud-input-pesq .mat-form-field-prefix .mat-icon{font-size:22px;line-height:1.025}::ng-deep .ps-crud-input-pesq mat-icon{margin-right:10px;color:#757575}::ng-deep .ps-crud-input-pesq input{padding:5px 0}::ng-deep .ps-crud-input-pesq label{margin-top:5px}::ng-deep .rb-crud-search-container{max-height:55px}::ng-deep .rb-crud-search-container div.mat-form-field-prefix{top:2px}::ng-deep .rb-crud-search-container .mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:16px}::ng-deep .rb-crud-search-container mat-form-field.mat-form-field{line-height:22px}::ng-deep mat-paginator.mat-paginator{width:100%}.ps-crud-header{padding:10px 24px;background-color:#fff}.ps-crud-content-filter{background:#f3f3f3;box-shadow:inset 0 4px 4px rgba(0,0,0,.06);padding:24px 24px 0}.ps-crud-content-button.rb-float-button{text-align:center;width:10px;padding:0 2px!important}.ps-crud-content-button.rb-float-button:last-child{padding-right:12px!important}td.ps-crud-content-button.mat-cell.rb-fixed-button-column,th.mat-header-cell.rb-fixed-button-column{width:116px;max-width:116px;text-align:center;padding-right:10px;padding-left:10px}td.ps-crud-content-button.mat-cell.rb-float-button-column,th.mat-header-cell.rb-float-button-column{text-align:center;width:10px;padding:0 2px!important}td.ps-crud-content-button.mat-cell.rb-float-button-column:last-child,th.mat-header-cell.rb-float-button-column:last-child{padding-right:12px!important}::ng-deep th.mat-header-cell.cdk-column-check.mat-column-check{width:45px;max-width:45px;min-width:45px!important}::ng-deep td.mat-cell.cdk-column-dragDrop.mat-column-dragDrop{width:30px;max-width:30px;min-width:30px!important}.rb-crud-table-active tr{background:#fff;cursor:move}.ps-crud-table th{font-weight:400;font-size:14px;color:#2d2d2d}.ps-crud-table tr{height:45px}.ps-crud-table td{font-weight:400;font-size:14px;color:grey;padding-right:20px}.menu-active{background:rgba(196,196,196,.3)}.menu-active button.rb-float-button,.menu-active mat-slide-toggle.rb-float-button{visibility:visible}::ng-deep tbody tr:hover{background:#f1f1f1}::ng-deep tbody tr:hover button.rb-float-button{visibility:visible}::ng-deep tbody tr:hover mat-slide-toggle.rb-float-button{visibility:visible}::ng-deep tbody tr button.rb-float-button{visibility:hidden}::ng-deep tbody tr mat-slide-toggle.rb-float-button{visibility:hidden}::ng-deep tbody tr.isVisible{background:#f1f1f1}::ng-deep tbody tr.isVisible button.rb-float-button{visibility:visible!important}::ng-deep tbody tr.isVisible mat-slide-toggle.rb-float-button{visibility:visible!important}::ng-deep tbody tr.isVisible button.rbCrudMenuButton{background:#c4c4c4!important;color:#000}.ps-crud-toggle{margin-right:5px}.ps-crud-button-tr{min-width:25px;line-height:27px;padding:0;margin:0 auto}.ps-crud-button-tr:last-child{margin-right:5px}.ps-crud-button-tr:hover:not([disabled]){background:#c4c4c4!important}.ps-crud-button-tr:hover:not([disabled]) mat-icon{color:#000000de}.ps-crud-button-tr:disabled{opacity:.4}.ps-crud-button-tr mat-icon{display:flex;justify-content:center;align-items:center;height:auto;width:auto;font-size:18px;color:#979797;margin:0 auto}::ng-deep .ps-crud-button-tr .mat-button-wrapper{display:flex;justify-content:center;align-items:center;height:24px}::ng-deep .ps-crud-button-link:hover:not([disabled]) mat-icon svg path{fill:#000000de}::ng-deep .ps-crud-content-menu-button{text-align:center;width:175px}::ng-deep .ps-crud-content-menu-button button{color:#000000de;font-size:14px}::ng-deep .ps-crud-content-menu-button mat-icon{color:#000000de!important;height:18px;width:18px;line-height:16px;font-size:20px}.ps-crud-button-menu{padding:0 35px;background:#ffb946;color:#fff;margin-bottom:8px}.scale-in-ver-top{-webkit-animation:.3s cubic-bezier(.25,.46,.45,.94) both scale-in-ver-top;animation:.3s cubic-bezier(.25,.46,.45,.94) both scale-in-ver-top}::ng-deep button.ps-crud-button-tr.rbCrudMenuButton{font-size:14px;font-weight:400;padding:0 0 0 4px;margin-right:0!important;color:#979797}::ng-deep button.ps-crud-button-tr.rbCrudMenuButton:disabled{color:#979797}::ng-deep button.ps-crud-button-tr.rbCrudMenuButton:hover:not([disabled]){color:#000}button.mat-menu-item.ng-star-inserted mat-icon.mat-icon{height:20px;width:16px;font-size:18px;margin-right:10px;line-height:16px}button.mat-menu-item.ng-star-inserted:not([disabled]),button.mat-menu-item.ng-star-inserted:not([disabled]) mat-icon.mat-icon{color:#000}button.mat-menu-item.ng-star-inserted:not([disabled]) mat-icon.mat-icon path{fill:#000}button.mat-menu-item.ng-star-inserted:disabled{color:#979797;opacity:.5}button.mat-menu-item.ng-star-inserted:disabled mat-icon.mat-icon{color:#979797}button.mat-menu-item.ng-star-inserted:disabled mat-icon.mat-icon path{fill:#979797}@-webkit-keyframes scale-in-ver-top{0%{transform:scaleY(0);transform-origin:100% 0;opacity:1}100%{transform:scaleY(1);transform-origin:100% 0;opacity:1}}@keyframes scale-in-ver-top{0%{transform:scaleY(0);transform-origin:100% 0;opacity:1}100%{transform:scaleY(1);transform-origin:100% 0;opacity:1}}.scale-out-ver-top{-webkit-animation:.2s cubic-bezier(.55,.085,.68,.53) both scale-out-ver-top;animation:.2s cubic-bezier(.55,.085,.68,.53) both scale-out-ver-top}@-webkit-keyframes scale-out-ver-top{0%{transform:scaleY(1);transform-origin:100% 0;opacity:1}100%{transform:scaleY(0);transform-origin:100% 0;opacity:1}}@keyframes scale-out-ver-top{0%{transform:scaleY(1);transform-origin:100% 0;opacity:1}100%{transform:scaleY(0);transform-origin:100% 0;opacity:1}}tr.mat-row.cdk-drag:not(.cdk-drag-disabled){cursor:move}tr.mat-row.cdk-drag.cdk-drag-disabled mat-icon.mat-icon.cdk-drag-handle{opacity:.3!important}.cdk-drag-preview{display:flex;width:100%;background:#fff;box-sizing:border-box;border-radius:4px;box-shadow:0 0 0 -3px rgba(0,0,0,.2),0 3px 6px 1px rgba(0,0,0,.14),0 3px 4px -2px rgba(0,0,0,.12)}.cdk-drag-preview .mat-cell{display:flex;align-items:center;flex:1 1 100%;border-bottom-style:none}.cdk-drag-preview .mat-cell button,.cdk-drag-preview .mat-cell mat-slide-toggle{visibility:hidden}.cdk-drag-preview td.mat-cell:first-of-type,.cdk-drag-preview td.mat-footer-cell:first-of-type,.cdk-drag-preview th.mat-header-cell:first-of-type{padding-left:24px}.cdk-drag-preview td{font-weight:400;font-size:14px;color:grey;padding-right:20px}.cdk-drag-preview td.mat-cell.cdk-column-dragDrop.mat-column-dragDrop{width:30px;max-width:30px}.cdk-drag-preview td.ps-crud-content-button.mat-cell.rb-float-button-column{width:10px;max-width:10px}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 150ms cubic-bezier(0,0,.2,1)}.ps-crud-table.cdk-drop-list-dragging .mat-row:not(.cdk-drag-placeholder){transition:transform 250ms cubic-bezier(0,0,.2,1)}.rb-crud-drag-active .rb-float-button{visibility:hidden}::ng-deep .mat-paginator-container{justify-content:space-between!important}::ng-deep .mat-paginator-range-label{margin:0!important}::ng-deep .rbHideCrudPaginator{display:none!important}@media (max-widh:500px){.ps-crud-header .mat-paginator-page-size{margin-right:auto}}"]
            }]
    }], function () { return [{ type: CrudService }]; }, { columns: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], initializePageSizeOptions: [{
            type: Input
        }], clickedButtonEdit: [{
            type: Output
        }], clickedButtonLink: [{
            type: Output
        }], clickedButtonDelete: [{
            type: Output
        }], pageEvent: [{
            type: Output
        }], content: [{
            type: ViewChild,
            args: [MatSort, { static: false }]
        }], getScreenWidth: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], displayedColumns: [{
            type: Input
        }], receivedData: [{
            type: Input
        }], descCrudEmpty: [{
            type: Input
        }], metaCount: [{
            type: Input
        }], msgCrudEmpty: [{
            type: Input
        }], menuOptions: [{
            type: Input
        }], parentScope: [{
            type: Input
        }], dragDrop: [{
            type: Input
        }], dragAction: [{
            type: Input
        }], disableSort: [{
            type: Input
        }], noHasPaginator: [{
            type: Input
        }], noHasSearch: [{
            type: Input
        }], minWidthScreenToSticky: [{
            type: Input
        }], table: [{
            type: ViewChild,
            args: [MatTable, { static: false }]
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], rbCrudContainer: [{
            type: ViewChild,
            args: ['rbCrudContainer', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    CrudComponent.prototype.displayedColumns;
    /** @type {?} */
    CrudComponent.prototype.receivedData;
    /** @type {?} */
    CrudComponent.prototype.descCrudEmpty;
    /** @type {?} */
    CrudComponent.prototype.columns;
    /** @type {?} */
    CrudComponent.prototype.metaCount;
    /** @type {?} */
    CrudComponent.prototype.msgCrudEmpty;
    /** @type {?} */
    CrudComponent.prototype.menuOptions;
    /** @type {?} */
    CrudComponent.prototype.parentScope;
    /** @type {?} */
    CrudComponent.prototype.dragDrop;
    /** @type {?} */
    CrudComponent.prototype.dragAction;
    /** @type {?} */
    CrudComponent.prototype.disableSort;
    /** @type {?} */
    CrudComponent.prototype.noHasPaginator;
    /** @type {?} */
    CrudComponent.prototype.noHasSearch;
    /** @type {?} */
    CrudComponent.prototype.minWidthScreenToSticky;
    /** @type {?} */
    CrudComponent.prototype.pageSizeOptions;
    /** @type {?} */
    CrudComponent.prototype.initializePageSizeOptions;
    /** @type {?} */
    CrudComponent.prototype.clickedButtonEdit;
    /** @type {?} */
    CrudComponent.prototype.clickedButtonLink;
    /** @type {?} */
    CrudComponent.prototype.clickedButtonDelete;
    /** @type {?} */
    CrudComponent.prototype.pageEvent;
    /** @type {?} */
    CrudComponent.prototype.table;
    /** @type {?} */
    CrudComponent.prototype.dataSource;
    /** @type {?} */
    CrudComponent.prototype.paginator;
    /** @type {?} */
    CrudComponent.prototype.selection;
    /** @type {?} */
    CrudComponent.prototype.mSort;
    /** @type {?} */
    CrudComponent.prototype.rbCrudContainer;
    /** @type {?} */
    CrudComponent.prototype.pageIndex;
    /** @type {?} */
    CrudComponent.prototype.pageSize;
    /** @type {?} */
    CrudComponent.prototype.length;
    /** @type {?} */
    CrudComponent.prototype.triggerFilter;
    /** @type {?} */
    CrudComponent.prototype.displayFilter;
    /** @type {?} */
    CrudComponent.prototype.selectedLineMenu;
    /** @type {?} */
    CrudComponent.prototype.selectedLineId;
    /** @type {?} */
    CrudComponent.prototype.isDrag;
    /** @type {?} */
    CrudComponent.prototype.isDraggableTable;
    /** @type {?} */
    CrudComponent.prototype.draggableDisableParam;
    /** @type {?} */
    CrudComponent.prototype.rbCrudContainerWidth;
    /** @type {?} */
    CrudComponent.prototype.screenWidth;
    /**
     * @type {?}
     * @private
     */
    CrudComponent.prototype.crudService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CrudModule {
}
CrudModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CrudModule });
CrudModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CrudModule_Factory(t) { return new (t || CrudModule)(); }, imports: [[
            MatButtonModule,
            MatIconModule,
            MatTableModule,
            MatButtonToggleModule,
            MatCheckboxModule,
            MatFormFieldModule,
            MatPaginatorModule,
            MatInputModule,
            MatSortModule,
            CommonModule,
            MatMenuModule,
            MatSlideToggleModule,
            DragDropModule,
            MatTooltipModule,
            FlexLayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CrudModule, { declarations: function () { return [CrudComponent]; }, imports: function () { return [MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatInputModule,
        MatSortModule,
        CommonModule,
        MatMenuModule,
        MatSlideToggleModule,
        DragDropModule,
        MatTooltipModule,
        FlexLayoutModule]; }, exports: function () { return [CrudComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CrudModule, [{
        type: NgModule,
        args: [{
                declarations: [CrudComponent],
                imports: [
                    MatButtonModule,
                    MatIconModule,
                    MatTableModule,
                    MatButtonToggleModule,
                    MatCheckboxModule,
                    MatFormFieldModule,
                    MatPaginatorModule,
                    MatInputModule,
                    MatSortModule,
                    CommonModule,
                    MatMenuModule,
                    MatSlideToggleModule,
                    DragDropModule,
                    MatTooltipModule,
                    FlexLayoutModule
                ],
                exports: [CrudComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const dutchRangeLabel = (/**
 * @param {?} page
 * @param {?} pageSize
 * @param {?} length
 * @return {?}
 */
(page, pageSize, length) => {
    if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    /** @type {?} */
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    /** @type {?} */
    const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
});
const ɵ0 = dutchRangeLabel;
/**
 * @return {?}
 */
function getDutchPaginatorIntl() {
    /** @type {?} */
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = 'Itens por página:';
    paginatorIntl.nextPageLabel = 'Próxima página';
    paginatorIntl.previousPageLabel = 'Página anterior';
    paginatorIntl.getRangeLabel = dutchRangeLabel;
    return paginatorIntl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShowPaletteCodeComponent {
    /**
     * @param {?} dialogRef
     * @param {?} dataCode
     */
    constructor(dialogRef, dataCode) {
        this.dialogRef = dialogRef;
        this.dataCode = dataCode;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log('dialogRef', this.dialogRef);
        console.log('data', this.dataCode);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    close(value) {
        this.dialogRef.close(value);
    }
}
ShowPaletteCodeComponent.ɵfac = function ShowPaletteCodeComponent_Factory(t) { return new (t || ShowPaletteCodeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ShowPaletteCodeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ShowPaletteCodeComponent, selectors: [["app-show-palette-code"]], decls: 11, vars: 2, consts: [[1, "settings-dialog-form"], ["mat-dialog-title", "", "fxLayout", "row", "fxLayoutAlign", "start center", 1, "rb-show-code-title"], ["fxFlex", ""], [1, "rb-show-code-closeButtonContainer"], ["color", "primary", "mat-icon-button", "", "title", "Fechar", 3, "mat-dialog-close"], ["aria-label", "Fechar"], [1, "rb-show-code-content"]], template: function ShowPaletteCodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵelementStart(5, "mat-icon", 5);
        ɵngcc0.ɵɵtext(6, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "mat-dialog-content", 6);
        ɵngcc0.ɵɵelementStart(8, "pre");
        ɵngcc0.ɵɵelementStart(9, "code");
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("mat-dialog-close", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.dataCode);
    } }, directives: [ɵngcc7.MatDialogTitle, ɵngcc2.DefaultLayoutDirective, ɵngcc2.DefaultLayoutAlignDirective, ɵngcc2.DefaultFlexDirective, ɵngcc13.MatButton, ɵngcc7.MatDialogClose, ɵngcc10.MatIcon, ɵngcc7.MatDialogContent], styles: [".rb-show-code-title.mat-dialog-title[_ngcontent-%COMP%]{margin-bottom:8px}.rb-dialog-container[_ngcontent-%COMP%] > mat-dialog-container[_ngcontent-%COMP%]{padding:10px 24px 0!important}.rb-show-code-closeButtonContainer[_ngcontent-%COMP%]{position:relative;height:40px}.rb-show-code-closeButtonContainer[_ngcontent-%COMP%]   button.mat-icon-button.mat-button-base.mat-primary[_ngcontent-%COMP%]{position:absolute;left:-29px;top:-1px}"] });
/** @nocollapse */
ShowPaletteCodeComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ShowPaletteCodeComponent, [{
        type: Component,
        args: [{
                selector: 'app-show-palette-code',
                template: "<div class=\"settings-dialog-form\">\n  <div mat-dialog-title class=\"rb-show-code-title\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n      <div fxFlex></div>\n      <div class=\"rb-show-code-closeButtonContainer\">\n          <button color=\"primary\" mat-icon-button [mat-dialog-close]=\"true\" title=\"Fechar\">\n              <mat-icon aria-label=\"Fechar\">close</mat-icon>\n          </button>\n      </div>\n  </div>\n  <mat-dialog-content class=\"rb-show-code-content\">\n    <pre><code>{{dataCode}}</code></pre>\n  </mat-dialog-content>\n</div>\n",
                styles: [".rb-show-code-title.mat-dialog-title{margin-bottom:8px}.rb-dialog-container>mat-dialog-container{padding:10px 24px 0!important}.rb-show-code-closeButtonContainer{position:relative;height:40px}.rb-show-code-closeButtonContainer button.mat-icon-button.mat-button-base.mat-primary{position:absolute;left:-29px;top:-1px}"]
            }]
    }], function () { return [{ type: ɵngcc7.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ShowPaletteCodeComponent.prototype.dialogRef;
    /** @type {?} */
    ShowPaletteCodeComponent.prototype.dataCode;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// export const rbTheming = {
//   `rb-primary`: `$rb-primary`,
//   `rb-accent`: `$rb-accent`,
//   `rb-warn`: `$rb-warn`,
// };
class ThemingManegerService {
    constructor() { }
    /**
     * @param {?} obj
     * @return {?}
     */
    changeTheme(obj) {
        this.setPrimaryThemeValues(obj.rbMainPalette);
        this.setAccentThemeValues(obj.rbAccentPalette);
    }
    /**
     * @private
     * @param {?} colorArray
     * @return {?}
     */
    setPrimaryThemeValues(colorArray) {
        /** @type {?} */
        let mainColorValue = ``;
        for (const [index, color] of colorArray.entries()) {
            document.documentElement.style.setProperty(`--rb-primary-theme-${color[`name`]}`, color[`hex`]);
            document.documentElement.style.setProperty(`--rb-primary-theme-contrast-${color[`name`]}`, color[`darkContrast`] === true ? `#000` : `#fff`);
            if (index === 5) {
                mainColorValue = color[`hex`];
            }
        }
        document.documentElement.style.setProperty(`--rb-primary-theme-RB900`, mainColorValue + `4d`);
        document.documentElement.style.setProperty(`--rb-primary-theme-contrast-RB900`, `#fff`);
    }
    /**
     * @private
     * @param {?} colorArray
     * @return {?}
     */
    setAccentThemeValues(colorArray) {
        /** @type {?} */
        let mainColorValue = ``;
        for (const [index, color] of colorArray.entries()) {
            document.documentElement.style.setProperty(`--rb-accent-theme-${color[`name`]}`, color[`hex`]);
            document.documentElement.style.setProperty(`--rb-accent-theme-contrast-${color[`name`]}`, color[`darkContrast`] === true ? `#000` : `#fff`);
            if (index === 5) {
                mainColorValue = color[`hex`];
            }
        }
        if (mainColorValue) {
            document.documentElement.style.setProperty(`--rb-accent-theme-RB900`, mainColorValue + `4d`);
            document.documentElement.style.setProperty(`--rb-accent-theme-contrast-RB900`, `#fff`);
        }
    }
}
ThemingManegerService.ɵfac = function ThemingManegerService_Factory(t) { return new (t || ThemingManegerService)(); };
ThemingManegerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ThemingManegerService, factory: ThemingManegerService.ɵfac, providedIn: 'root' });
/** @nocollapse */
ThemingManegerService.ctorParameters = () => [];
/** @nocollapse */ ThemingManegerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ThemingManegerService_Factory() { return new ThemingManegerService(); }, token: ThemingManegerService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ThemingManegerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// const tinycolor = new TinyColor('red');
// @NgModule({
//   declarations: [],
//   imports: [
//     CommonModule
//   ]
// })
class ColorPaletteGeneratorService {
    constructor() {
        this.themingManegerService = new ThemingManegerService();
        this.themeData = {
            rbMainPalette: {
                colors: [],
                orig: [],
                base: '#10807f',
                json: '',
                name: '',
                angularCodeString: '',
            },
            rbAccentPalette: {
                colors: [],
                orig: [],
                base: '#717171',
                json: '',
                name: '',
                angularCodeString: '',
            },
        };
    }
    /**
     * @param {?} data
     * @return {?}
     */
    setThemeData(data) {
        if (data) {
            this.themeData = JSON.parse(JSON.stringify(data));
        }
        else {
            this.themeData = this.resetOriginalValues();
        }
    }
    /**
     * @return {?}
     */
    getThemeData() {
        return JSON.parse(JSON.stringify(this.themeData));
    }
    /**
     * @return {?}
     */
    resetOriginalValues() {
        return {
            rbMainPalette: {
                colors: [],
                orig: [],
                base: '#10807f',
                json: '',
                name: ''
            },
            rbAccentPalette: {
                colors: [],
                orig: [],
                base: '#717171',
                json: '',
                name: '',
                angularCodeString: '',
            },
        };
    }
    /**
     * @param {?} value
     * @param {?} colorBaseObj
     * @param {?} colorBaseModel
     * @param {?} parentScope
     * @param {?} paletteSettings
     * @return {?}
     */
    changePalette(value, colorBaseObj, colorBaseModel, parentScope, paletteSettings) {
        /** @type {?} */
        const hexValue = new TinyColor(parentScope[paletteSettings].base).toHexString();
        colorBaseObj[colorBaseModel] = hexValue;
        parentScope[paletteSettings].colors = this.buildNewPalette(hexValue);
        this.createPaletteStrCode(parentScope[paletteSettings].colors, parentScope, paletteSettings);
        if (parentScope && typeof parentScope.setHasChange === 'function') {
            parentScope.setHasChange(value);
        }
    }
    /**
     * @param {?} hex
     * @return {?}
     */
    buildNewPalette(hex) {
        /** @type {?} */
        const lightBase = new TinyColor('#ffffff');
        /** @type {?} */
        const darkBase = this.buildDarkBase(new TinyColor(hex).toRgb(), new TinyColor(hex).toRgb());
        /** @type {?} */
        const triadbase = new TinyColor(hex).tetrad();
        return [
            this.getColorObject(this.rbMixColor(lightBase, hex, 12), '50'),
            this.getColorObject(this.rbMixColor(lightBase, hex, 30), '100'),
            this.getColorObject(this.rbMixColor(lightBase, hex, 50), '200'),
            this.getColorObject(this.rbMixColor(lightBase, hex, 70), '300'),
            this.getColorObject(this.rbMixColor(lightBase, hex, 85), '400'),
            this.getColorObject(this.rbMixColor(lightBase, hex, 100), '500'),
            this.getColorObject(this.rbMixColor(darkBase, hex, 87), '600'),
            this.getColorObject(this.rbMixColor(darkBase, hex, 70), '700'),
            this.getColorObject(this.rbMixColor(darkBase, hex, 54), '800'),
            this.getColorObject(this.rbMixColor(darkBase, hex, 25), '900'),
            this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(80).lighten(65), 'A100'),
            this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(80).lighten(55), 'A200'),
            this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(100).lighten(45), 'A400'),
            this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(100).lighten(40), 'A700')
        ];
    }
    /**
     * @param {?} rgb1
     * @param {?} rgb2
     * @return {?}
     */
    buildDarkBase(rgb1, rgb2) {
        rgb1.b = Math.floor(rgb1.b * rgb2.b / 255);
        rgb1.g = Math.floor(rgb1.g * rgb2.g / 255);
        rgb1.r = Math.floor(rgb1.r * rgb2.r / 255);
        return new TinyColor('rgb ' + rgb1.r + ' ' + rgb1.g + ' ' + rgb1.b);
    }
    /**
     * @param {?} value
     * @param {?} name
     * @return {?}
     */
    getColorObject(value, name) {
        /** @type {?} */
        const c = new TinyColor(value);
        return {
            name: name,
            hex: c.toHexString(),
            hexValue: c.toHex(),
            rgbValue: c.toRgb(),
            rgbString: c.toRgbString(),
            darkContrast: c.isLight()
        };
    }
    /**
     * @param {?} baseLight
     * @param {?} hex
     * @param {?} value
     * @return {?}
     */
    rbMixColor(baseLight, hex, value) {
        return baseLight.mix(hex, value);
    }
    /**
     * @param {?} value
     * @param {?} colorBaseObj
     * @param {?} colorBaseModel
     * @param {?} parentScope
     * @param {?} paletteSettings
     * @return {?}
     */
    refreshColor(value, colorBaseObj, colorBaseModel, parentScope, paletteSettings) {
        if (!value || value === '') {
            colorBaseObj[colorBaseModel] = '#10807f';
        }
        else {
            colorBaseObj[colorBaseModel] = value;
        }
        parentScope[paletteSettings].base = colorBaseObj[colorBaseModel];
        this.changePalette(0, colorBaseObj, colorBaseModel, parentScope, paletteSettings);
    }
    /**
     * @param {?} arrayColors
     * @param {?} parentScope
     * @param {?} paletteSettings
     * @return {?}
     */
    createPaletteStrCode(arrayColors, parentScope, paletteSettings) {
        /** @type {?} */
        const colors = [];
        /** @type {?} */
        let palleteCode = '$md-mcgpalette0:( ';
        palleteCode += `
        `;
        for (const item of arrayColors) {
            palleteCode += item.name + ' : ' + item.hex + ', ';
            palleteCode += `
        `;
        }
        palleteCode += 'contrast: (';
        palleteCode += `
          `;
        for (const item of arrayColors) {
            palleteCode += item.name + ' : ' + (item.darkContrast ? '#000000' : '#ffffff') + ', ';
            if (item + 1 < arrayColors.length) {
                palleteCode += `
          `;
            }
            else {
                palleteCode += `
        `;
            }
        }
        palleteCode += `)
    );`;
        parentScope[paletteSettings].angularCodeString = palleteCode;
    }
    /**
     * @param {?} newTheme
     * @param {?} theme
     * @return {?}
     */
    changeTheme(newTheme, theme) {
        this.themingManegerService.changeTheme(newTheme);
        this.setThemeData(theme);
    }
}
ColorPaletteGeneratorService.ɵfac = function ColorPaletteGeneratorService_Factory(t) { return new (t || ColorPaletteGeneratorService)(); };
ColorPaletteGeneratorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ColorPaletteGeneratorService, factory: ColorPaletteGeneratorService.ɵfac, providedIn: 'root' });
/** @nocollapse */ ColorPaletteGeneratorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ColorPaletteGeneratorService_Factory() { return new ColorPaletteGeneratorService(); }, token: ColorPaletteGeneratorService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPaletteGeneratorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    ColorPaletteGeneratorService.prototype.themingManegerService;
    /** @type {?} */
    ColorPaletteGeneratorService.prototype.themeData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ColorPaletteGeneratorComponent {
    /**
     * @param {?} matDialog
     * @param {?} colorPaletteGeneratorService
     */
    constructor(matDialog, colorPaletteGeneratorService) {
        this.matDialog = matDialog;
        this.colorPaletteGeneratorService = colorPaletteGeneratorService;
        this.disableClickOnCircle = false;
        this.fxFlexLeft = 30;
        this.fxFlexRight = 70;
        this.position = 'bottom';
        this.title = 'Cor institucional';
        this.displayInfos = true;
        this.textInfo = 'A definição da cor institucional norteará a identidade visual<br>' +
            'do sistema entre títulos, botões e demais ícones <br>' +
            'de todas as páginas.';
        this.hasChange = new Subject();
        this.displayedPalette = false;
        this.toggle = false;
        this.paletteSettings = {};
        this.colorBaseBackup = '';
        this.refreshColor = (/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            this.colorPaletteGeneratorService.refreshColor(value, this.colorBaseObj, this.colorBaseModel, this, 'paletteSettings');
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setInitialColorBase();
    }
    /**
     * @return {?}
     */
    setInitialColorBase() {
        if (!this.colorBaseObj[this.colorBaseModel]) {
            this.colorBaseObj[this.colorBaseModel] = '#10807f';
        }
        this.paletteSettings.base = this.colorBaseObj[this.colorBaseModel];
        this.colorBaseBackup = this.paletteSettings.base;
        this.changePalette(0);
    }
    // createColorBaseWithoutComponentView(colorBase) {
    //   if (!colorBase) {
    //     colorBase = '#10807f';
    //   }
    //   this.paletteSettings.base = colorBase;
    //   this.colorBaseBackup = this.paletteSettings.base;
    //   this.changePalette(0);
    // }
    /**
     * @return {?}
     */
    getPaletteSettings() {
        return this.paletteSettings;
    }
    /**
     * @return {?}
     */
    getPaletteCode() {
        return this.paletteSettings.angularCodeString;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    changePalette(value) {
        this.colorPaletteGeneratorService.changePalette(value, this.colorBaseObj, this.colorBaseModel, this, 'paletteSettings');
    }
    /**
     * @return {?}
     */
    showPalette() {
        this.displayedPalette = !this.displayedPalette;
    }
    /**
     * @return {?}
     */
    showPaletteCode() {
        /** @type {?} */
        const showPaletteCodeDialog = new MatDialogConfig();
        showPaletteCodeDialog.autoFocus = false;
        showPaletteCodeDialog.restoreFocus = false;
        showPaletteCodeDialog.minWidth = '50%';
        showPaletteCodeDialog.maxWidth = '95%';
        showPaletteCodeDialog.minHeight = '25%';
        showPaletteCodeDialog.maxHeight = '95%';
        showPaletteCodeDialog.panelClass = 'rb-dialog-container';
        showPaletteCodeDialog.data = this.getAngularCodeString();
        /** @type {?} */
        const showPaletteCodeComponentRef = this.matDialog.open(ShowPaletteCodeComponent, showPaletteCodeDialog);
    }
    /**
     * @return {?}
     */
    getAngularCodeString() {
        if (this.paletteSettings && this.paletteSettings.angularCodeString) {
            return this.paletteSettings.angularCodeString;
        }
        else {
            return '';
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    setHasChange(value) {
        this.hasChange.next(value);
    }
    /**
     * @return {?}
     */
    getHasChange() {
        return this.hasChange.asObservable();
    }
    /**
     * @param {?} newTheme
     * @param {?} theme
     * @return {?}
     */
    changeTheme(newTheme, theme) {
        this.colorPaletteGeneratorService.changeTheme(newTheme, theme);
    }
}
ColorPaletteGeneratorComponent.ɵfac = function ColorPaletteGeneratorComponent_Factory(t) { return new (t || ColorPaletteGeneratorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.MatDialog), ɵngcc0.ɵɵdirectiveInject(ColorPaletteGeneratorService)); };
ColorPaletteGeneratorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorPaletteGeneratorComponent, selectors: [["rb-color-palette-generator"]], inputs: { disableClickOnCircle: "disableClickOnCircle", fxFlexLeft: "fxFlexLeft", fxFlexRight: "fxFlexRight", position: "position", title: "title", displayInfos: "displayInfos", textInfo: "textInfo", mainTitle: "mainTitle", colorBaseModel: "colorBaseModel", colorBaseObj: "colorBaseObj", displayEditButton: "displayEditButton", displayView: "displayView", displayRefresh: "displayRefresh", displayCode: "displayCode", parentScope: "parentScope" }, decls: 20, vars: 35, consts: [["fxLayout", "row", "fxLayout.sm", "column", "fxLayout.xs", "column", 1, "rb-div-form"], [1, "rbPalleteColorActions", 3, "fxFlex"], [1, "rb-title-palette"], ["fxLayoutAlign", "start center"], [1, "RbColorPickerSelector", 3, "ngClass", "cpPosition", "cpPositionOffset", "cpIgnoredElements", "cpToggle", "cpPositionRelativeToArrow", "cpCancelButton", "cpCancelButtonText", "cpCancelButtonClass", "cpOKButton", "cpOKButtonText", "cpOKButtonClass", "colorPicker", "cpToggleChange", "colorPickerSelect", "colorPickerChange"], ["rbPalleteColorSelector", ""], ["class", "RbColorPickerTooltip", 4, "ngIf"], ["class", "RbCPActionsDivisor", 4, "ngIf"], ["mat-button", "", "aria-label", "Editar", "class", "RbColorPickerEdit", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "color", "primary", "aria-label", "Voltar a cor anterior", "class", "RbColorPickerCode", 3, "matTooltip", "click", 4, "ngIf"], ["mat-icon-button", "", "color", "primary", "aria-label", "Restaurar cor", "class", "RbColorPickerCode", "matTooltip", "Restaurar cor", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "color", "primary", "aria-label", "C\u00F3digo da paleta", "class", "RbColorPickerCode", "matTooltip", "Visualizar c\u00F3digo", 3, "click", 4, "ngIf"], ["class", "ps-file-content-action", 3, "fxFlex", 4, "ngIf"], ["fxLayout", "row"], ["fxFlex", "100"], ["role", "list", "class", "rbPalleteColorList", 4, "ngIf"], [1, "RbColorPickerTooltip"], [1, "RbCPActionsDivisor"], ["mat-button", "", "aria-label", "Editar", 1, "RbColorPickerEdit", 3, "click"], ["ignoredButton", ""], ["mat-icon-button", "", "color", "primary", "aria-label", "Voltar a cor anterior", 1, "RbColorPickerCode", 3, "matTooltip", "click"], ["mat-icon-button", "", "color", "primary", "aria-label", "Restaurar cor", "matTooltip", "Restaurar cor", 1, "RbColorPickerCode", 3, "click"], ["mat-icon-button", "", "color", "primary", "aria-label", "C\u00F3digo da paleta", "matTooltip", "Visualizar c\u00F3digo", 1, "RbColorPickerCode", 3, "click"], [1, "ps-file-content-action", 3, "fxFlex"], ["fxLayout", "column"], ["fxFlex", "100", 1, "rbPalleteColorLegend"], [3, "innerHTML"], ["role", "list", 1, "rbPalleteColorList"], ["role", "listitem", 3, "ngClass", "ngStyle", 4, "ngFor", "ngForOf"], ["role", "listitem", 3, "ngClass", "ngStyle"], [1, "rbPalleteColorName"], [1, "rbPalleteColorCode"]], template: function ColorPaletteGeneratorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4, 5);
        ɵngcc0.ɵɵlistener("cpToggleChange", function ColorPaletteGeneratorComponent_Template_div_cpToggleChange_5_listener($event) { return ctx.toggle = $event; })("colorPickerSelect", function ColorPaletteGeneratorComponent_Template_div_colorPickerSelect_5_listener() { return ctx.changePalette(1); })("colorPickerChange", function ColorPaletteGeneratorComponent_Template_div_colorPickerChange_5_listener($event) { return ctx.paletteSettings.base = $event; });
        ɵngcc0.ɵɵtemplate(7, ColorPaletteGeneratorComponent_span_7_Template, 2, 0, "span", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, ColorPaletteGeneratorComponent_span_8_Template, 1, 0, "span", 7);
        ɵngcc0.ɵɵtemplate(9, ColorPaletteGeneratorComponent_a_9_Template, 5, 0, "a", 8);
        ɵngcc0.ɵɵtemplate(10, ColorPaletteGeneratorComponent_span_10_Template, 1, 0, "span", 7);
        ɵngcc0.ɵɵtemplate(11, ColorPaletteGeneratorComponent_a_11_Template, 3, 2, "a", 9);
        ɵngcc0.ɵɵtemplate(12, ColorPaletteGeneratorComponent_span_12_Template, 1, 0, "span", 7);
        ɵngcc0.ɵɵtemplate(13, ColorPaletteGeneratorComponent_a_13_Template, 3, 0, "a", 10);
        ɵngcc0.ɵɵtemplate(14, ColorPaletteGeneratorComponent_span_14_Template, 1, 0, "span", 7);
        ɵngcc0.ɵɵtemplate(15, ColorPaletteGeneratorComponent_a_15_Template, 3, 0, "a", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, ColorPaletteGeneratorComponent_div_16_Template, 4, 2, "div", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 13);
        ɵngcc0.ɵɵelementStart(18, "div", 14);
        ɵngcc0.ɵɵtemplate(19, ColorPaletteGeneratorComponent_mat_list_19_Template, 2, 1, "mat-list", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fxFlex", ctx.fxFlexLeft);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("color", ctx.paletteSettings.base)("background", ctx.paletteSettings.base, ɵngcc0.ɵɵdefaultStyleSanitizer);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(30, _c11, ctx.disableClickOnCircle))("cpPosition", ctx.position)("cpPositionOffset", "50%")("cpIgnoredElements", ɵngcc0.ɵɵpureFunction2(32, _c12, ctx.disableClickOnCircle ? _r0 : "", ctx.ignoredButton))("cpToggle", ctx.toggle)("cpPositionRelativeToArrow", true)("cpCancelButton", true)("cpCancelButtonText", "Cancelar")("cpCancelButtonClass", "RbColorPicker RbCPCancel")("cpOKButton", true)("cpOKButtonText", "Aplicar")("cpOKButtonClass", "RbColorPicker RbCPApply")("colorPicker", ctx.paletteSettings.base);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disableClickOnCircle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayEditButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayEditButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayRefresh);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayRefresh);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayCode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayCode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayInfos);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayedPalette);
    } }, directives: [ɵngcc2.DefaultLayoutDirective, ɵngcc2.DefaultFlexDirective, ɵngcc2.DefaultLayoutAlignDirective, ɵngcc3.NgClass, ɵngcc4.DefaultClassDirective, ɵngcc16.ColorPickerDirective, ɵngcc3.NgIf, ɵngcc13.MatAnchor, ɵngcc10.MatIcon, ɵngcc15.MatTooltip, ɵngcc17.MatList, ɵngcc3.NgForOf, ɵngcc17.MatListItem, ɵngcc3.NgStyle, ɵngcc4.DefaultStyleDirective], styles: [".rb-show-code-title.mat-dialog-title[_ngcontent-%COMP%]{margin-bottom:8px}.rb-dialog-container[_ngcontent-%COMP%] > mat-dialog-container[_ngcontent-%COMP%]{padding:10px 24px 0!important}.rb-show-code-closeButtonContainer[_ngcontent-%COMP%]{position:relative;height:40px}.rb-show-code-closeButtonContainer[_ngcontent-%COMP%]   button.mat-icon-button.mat-button-base.mat-primary[_ngcontent-%COMP%]{position:absolute;left:-29px;top:-1px}  .rb-light-contrast-color{color:rgba(255,255,255,.87)!important;text-shadow:1px 1px 0 rgba(0,0,0,.1)!important}  .rb-dark-contrast-color{color:#000!important;text-shadow:1px 1px 0 rgba(255,255,255,.1)!important}  span.rbPalleteColorName{font-weight:600;margin-right:8px;font-size:16px}  span.rbPalleteColorCode{font-weight:200;margin-right:8px;font-size:12px;text-transform:uppercase}  .rbPalleteColorActions{padding:10px;min-width:200px}  .rbPalleteColorActions   button.RbColorPicker{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:30px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);width:75px}  .rbPalleteColorActions   button.RbColorPicker.RbCPCancel{background-color:#7c7c7c;color:#fff;margin-right:5px}  .rbPalleteColorActions   button.RbColorPicker.RbCPApply{background-color:#2d807f;color:#fff;margin-right:5px}  .rbPalleteColorActions   .RbColorPickerEdit{color:#333}  .rbPalleteColorActions   .RbColorPickerEdit mat-icon{font-size:21px;height:21px;width:21px;display:inline-flex;justify-content:center;align-items:center;position:relative;top:-2px;margin-right:5px}  .rbPalleteColorActions   div.RbColorPickerSelector{position:relative;display:inline-block;height:40px;width:40px;border-radius:50%;border:1px solid #80808050}  .rbPalleteColorActions   div.RbColorPickerSelector:hover{cursor:pointer}  .rbPalleteColorActions   span.RbCPActionsDivisor{width:10px}  .rbPalleteColorLegend p{line-height:154.2%;letter-spacing:.025em;font-style:normal;font-weight:400;font-size:15px;color:grey}  label.rb-main-label.rb-title-palette{text-transform:capitalize}.rb-title-palette[_ngcontent-%COMP%]{font-family:poppins,sans-serif;font-style:normal;font-size:1rem;color:#4d4d4d;font-weight:500} .RbColorPickerSelectorDisable{cursor:default!important} .RbColorPickerSelector:hover .RbColorPickerTooltip{transform:scale(1)}.RbColorPickerTooltip[_ngcontent-%COMP%]{display:block;transform:scale(0);color:#fff;border-radius:4px;max-width:250px;overflow:hidden;text-overflow:ellipsis;background:rgba(97,97,97,.9);font-size:9px;position:absolute;bottom:-39px;left:-20px;width:70px;text-align:center;padding:6px 8px 7px}"] });
/** @nocollapse */
ColorPaletteGeneratorComponent.ctorParameters = () => [
    { type: MatDialog },
    { type: ColorPaletteGeneratorService }
];
ColorPaletteGeneratorComponent.propDecorators = {
    mainTitle: [{ type: Input }],
    colorBaseModel: [{ type: Input }],
    colorBaseObj: [{ type: Input }],
    displayEditButton: [{ type: Input }],
    displayView: [{ type: Input }],
    displayRefresh: [{ type: Input }],
    displayCode: [{ type: Input }],
    disableClickOnCircle: [{ type: Input }],
    parentScope: [{ type: Input }],
    fxFlexLeft: [{ type: Input }],
    fxFlexRight: [{ type: Input }],
    position: [{ type: Input }],
    title: [{ type: Input }],
    displayInfos: [{ type: Input }],
    textInfo: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPaletteGeneratorComponent, [{
        type: Component,
        args: [{
                selector: 'rb-color-palette-generator',
                template: "<div fxLayout=\"row\" fxLayout.sm=\"column\" fxLayout.xs=\"column\" class=\"rb-div-form\">\n  <div [fxFlex]=\"fxFlexLeft\" class=\"rbPalleteColorActions\">\n    <p class=\"rb-title-palette\">{{title}}</p>\n    <div fxLayoutAlign=\"start center\">\n      <div class=\"RbColorPickerSelector\" #rbPalleteColorSelector\n        [ngClass]=\"{'RbColorPickerSelectorDisable': disableClickOnCircle}\"\n        [style.color]=\"paletteSettings.base\"\n        [cpPosition]=\"position\"\n        [cpPositionOffset]=\"'50%'\"\n        [cpIgnoredElements]=\"[disableClickOnCircle ? rbPalleteColorSelector: '', ignoredButton]\"\n        [(cpToggle)]=\"toggle\"\n        [cpPositionRelativeToArrow]=\"true\"\n        [style.background]=\"paletteSettings.base\"\n        (colorPickerSelect)=\"changePalette(1)\"\n        [cpCancelButton]=\"true\"\n        [cpCancelButtonText]=\"'Cancelar'\"\n        [cpCancelButtonClass]=\"'RbColorPicker RbCPCancel'\"\n        [cpOKButton]=\"true\"\n        [cpOKButtonText]=\"'Aplicar'\"\n        [cpOKButtonClass]=\"'RbColorPicker RbCPApply'\"\n        [(colorPicker)]=\"paletteSettings.base\">\n        <span class=\"RbColorPickerTooltip\" *ngIf=\"!disableClickOnCircle\">Escolha uma cor</span>\n      </div>\n      <span class=\"RbCPActionsDivisor\" *ngIf=\"displayEditButton\"></span>\n      <a\n        mat-button\n        *ngIf=\"displayEditButton\"\n        aria-label=\"Editar\"\n        class=\"RbColorPickerEdit\"\n        #ignoredButton (click)=\"toggle=!toggle\">\n        <mat-icon>edit</mat-icon>\n        Editar\n      </a>\n      <span class=\"RbCPActionsDivisor\" *ngIf=\"displayView\"></span>\n      <a mat-icon-button *ngIf=\"displayView\"\n        color=\"primary\"\n        aria-label=\"Voltar a cor anterior\"\n        (click)=\"showPalette()\"\n        class=\"RbColorPickerCode\"\n        matTooltip=\"{{displayedPalette ? 'Esconder paleta de cores' : 'Exibir paleta de cores'}}\">\n        <mat-icon>{{displayedPalette ? 'visibility' : 'visibility_off'}}</mat-icon>\n      </a>\n      <span class=\"RbCPActionsDivisor\" *ngIf=\"displayRefresh\"></span>\n      <a mat-icon-button *ngIf=\"displayRefresh\"\n        color=\"primary\"\n        aria-label=\"Restaurar cor\"\n        (click)=\"refreshColor(colorBaseBackup)\"\n        class=\"RbColorPickerCode\"\n        matTooltip=\"Restaurar cor\">\n        <mat-icon>refresh</mat-icon>\n      </a>\n      <span class=\"RbCPActionsDivisor\" *ngIf=\"displayCode\"></span>\n      <a mat-icon-button *ngIf=\"displayCode\"\n        color=\"primary\"\n        aria-label=\"C\u00F3digo da paleta\"\n        class=\"RbColorPickerCode\"\n        (click)=\"showPaletteCode()\"\n        matTooltip=\"Visualizar c\u00F3digo\">\n        <mat-icon>code</mat-icon>\n      </a>\n    </div>\n  </div>\n  <div [fxFlex]=\"fxFlexRight\" *ngIf=\"displayInfos\" class=\"ps-file-content-action\">\n    <div fxLayout=\"column\">\n      <div fxFlex=\"100\" class=\"rbPalleteColorLegend\">\n        <p [innerHTML]=\"textInfo\"></p>\n      </div>\n    </div>\n  </div>\n</div>\n<div fxLayout=\"row\">\n  <div fxFlex=\"100\">\n    <mat-list role=\"list\" class=\"rbPalleteColorList\" *ngIf=\"displayedPalette\">\n      <mat-list-item role=\"listitem\"\n        *ngFor=\"let color of paletteSettings.colors\"\n        [ngClass]=\"{'rb-dark-contrast-color': color.darkContrast,\n        'rb-light-contrast-color': !color.darkContrast}\"\n        [ngStyle]=\"{'background-color': color.hex}\">\n        <span class=\"rbPalleteColorName\">{{color.name}}</span>\n        <span class=\"rbPalleteColorCode\">{{color.hex}}</span>\n      </mat-list-item>\n    </mat-list>\n  </div>\n</div>\n",
                styles: [".rb-show-code-title.mat-dialog-title{margin-bottom:8px}.rb-dialog-container>mat-dialog-container{padding:10px 24px 0!important}.rb-show-code-closeButtonContainer{position:relative;height:40px}.rb-show-code-closeButtonContainer button.mat-icon-button.mat-button-base.mat-primary{position:absolute;left:-29px;top:-1px}::ng-deep .rb-light-contrast-color{color:rgba(255,255,255,.87)!important;text-shadow:1px 1px 0 rgba(0,0,0,.1)!important}::ng-deep .rb-dark-contrast-color{color:#000!important;text-shadow:1px 1px 0 rgba(255,255,255,.1)!important}::ng-deep span.rbPalleteColorName{font-weight:600;margin-right:8px;font-size:16px}::ng-deep span.rbPalleteColorCode{font-weight:200;margin-right:8px;font-size:12px;text-transform:uppercase}::ng-deep .rbPalleteColorActions{padding:10px;min-width:200px}::ng-deep .rbPalleteColorActions ::ng-deep button.RbColorPicker{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:30px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);width:75px}::ng-deep .rbPalleteColorActions ::ng-deep button.RbColorPicker.RbCPCancel{background-color:#7c7c7c;color:#fff;margin-right:5px}::ng-deep .rbPalleteColorActions ::ng-deep button.RbColorPicker.RbCPApply{background-color:#2d807f;color:#fff;margin-right:5px}::ng-deep .rbPalleteColorActions ::ng-deep .RbColorPickerEdit{color:#333}::ng-deep .rbPalleteColorActions ::ng-deep .RbColorPickerEdit mat-icon{font-size:21px;height:21px;width:21px;display:inline-flex;justify-content:center;align-items:center;position:relative;top:-2px;margin-right:5px}::ng-deep .rbPalleteColorActions ::ng-deep div.RbColorPickerSelector{position:relative;display:inline-block;height:40px;width:40px;border-radius:50%;border:1px solid #80808050}::ng-deep .rbPalleteColorActions ::ng-deep div.RbColorPickerSelector:hover{cursor:pointer}::ng-deep .rbPalleteColorActions ::ng-deep span.RbCPActionsDivisor{width:10px}::ng-deep .rbPalleteColorLegend p{line-height:154.2%;letter-spacing:.025em;font-style:normal;font-weight:400;font-size:15px;color:grey}::ng-deep label.rb-main-label.rb-title-palette{text-transform:capitalize}.rb-title-palette{font-family:poppins,sans-serif;font-style:normal;font-size:1rem;color:#4d4d4d;font-weight:500}::ng-deep.RbColorPickerSelectorDisable{cursor:default!important}::ng-deep.RbColorPickerSelector:hover .RbColorPickerTooltip{transform:scale(1)}.RbColorPickerTooltip{display:block;transform:scale(0);color:#fff;border-radius:4px;max-width:250px;overflow:hidden;text-overflow:ellipsis;background:rgba(97,97,97,.9);font-size:9px;position:absolute;bottom:-39px;left:-20px;width:70px;text-align:center;padding:6px 8px 7px}"]
            }]
    }], function () { return [{ type: ɵngcc7.MatDialog }, { type: ColorPaletteGeneratorService }]; }, { disableClickOnCircle: [{
            type: Input
        }], fxFlexLeft: [{
            type: Input
        }], fxFlexRight: [{
            type: Input
        }], position: [{
            type: Input
        }], title: [{
            type: Input
        }], displayInfos: [{
            type: Input
        }], textInfo: [{
            type: Input
        }], mainTitle: [{
            type: Input
        }], colorBaseModel: [{
            type: Input
        }], colorBaseObj: [{
            type: Input
        }], displayEditButton: [{
            type: Input
        }], displayView: [{
            type: Input
        }], displayRefresh: [{
            type: Input
        }], displayCode: [{
            type: Input
        }], parentScope: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.mainTitle;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.colorBaseModel;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.colorBaseObj;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.displayEditButton;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.displayView;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.displayRefresh;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.displayCode;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.disableClickOnCircle;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.parentScope;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.fxFlexLeft;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.fxFlexRight;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.position;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.title;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.displayInfos;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.textInfo;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.hasChange;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.displayedPalette;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.toggle;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.paletteSettings;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.colorBaseBackup;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.ignoredButton;
    /** @type {?} */
    ColorPaletteGeneratorComponent.prototype.refreshColor;
    /**
     * @type {?}
     * @private
     */
    ColorPaletteGeneratorComponent.prototype.matDialog;
    /**
     * @type {?}
     * @private
     */
    ColorPaletteGeneratorComponent.prototype.colorPaletteGeneratorService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ColorPaletteGeneratorModule {
}
ColorPaletteGeneratorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ColorPaletteGeneratorModule });
ColorPaletteGeneratorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ColorPaletteGeneratorModule_Factory(t) { return new (t || ColorPaletteGeneratorModule)(); }, imports: [[
            CommonModule,
            ColorPickerModule,
            MatTooltipModule,
            MatButtonModule$1,
            MatDialogModule,
            MatIconModule,
            MatListModule,
            FlexLayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ColorPaletteGeneratorModule, { declarations: function () { return [ColorPaletteGeneratorComponent,
        ShowPaletteCodeComponent]; }, imports: function () { return [CommonModule,
        ColorPickerModule,
        MatTooltipModule,
        MatButtonModule$1,
        MatDialogModule,
        MatIconModule,
        MatListModule,
        FlexLayoutModule]; }, exports: function () { return [ColorPaletteGeneratorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPaletteGeneratorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ColorPaletteGeneratorComponent,
                    ShowPaletteCodeComponent
                ],
                imports: [
                    CommonModule,
                    ColorPickerModule,
                    MatTooltipModule,
                    MatButtonModule$1,
                    MatDialogModule,
                    MatIconModule,
                    MatListModule,
                    FlexLayoutModule
                ],
                exports: [
                    ColorPaletteGeneratorComponent
                ],
                entryComponents: [
                    ShowPaletteCodeComponent,
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ColorPaletteGeneratorComponent, ColorPaletteGeneratorModule, ColorPaletteGeneratorService, CrudComponent, CrudModule, CrudService, ThemingManegerService, getDutchPaginatorIntl, ShowPaletteCodeComponent as ɵa };

//# sourceMappingURL=rubeus-components.js.map